/* C262: swatch colours for blank apparel synced from Ninja Transfers through Shopify Collective.
 *
 * Collective copies the product and variant record but NOT metafields, so the per-variant swatch
 * hex Ninja keeps in specs.shirt_prim_hex never arrives. The theme then paints
 * background-color:<colour name with spaces stripped> — 'Caribbean Blue' becomes
 * background-color:caribbeanblue, which is invalid and paints nothing. That is why a handful of
 * swatches looked right and the rest were empty rings: it reads like a CSS bug but it is missing
 * data.
 *
 * Keyed by colour NAME, which does survive the sync as the variant option value, so this file
 * does not need rebuilding after every import — only when new colour names appear.
 *
 * Built 2798 of 2802 names in use. Regenerate with build-swatch-asset.py.
 */
(function () {
  /* C336: several sections load this file (hats template, upsell rail, product section). Run once, so the
     page never carries more than one observer repainting on every DOM change. */
  if (window.__npBlankSwatchPainter) return;
  window.__npBlankSwatchPainter = true;
  var MAP = {
"AB-Fluorescent Yellow/ Green": "#fae574",
"ALPINE GREEN": "#244C41",
"AMETHYST": "#763D9C",
"ANCHOR SLATE": "#4F576E",
"ANTIQ CHERRY RED": "#C93452",
"ANTIQUE DENIM": "#676F71",
"ANTIQUE GOLD": "#DD974A",
"ANTIQUE RED": "#A4343A",
"ANTIQUE WHITE": "#FFFFFF",
"ANTIQUE WHT TRBL": "#EBEBE9",
"ANTQUE HELICONIA": "#CB1A75",
"ANTQUE RED/ TAN": "#BC1F35",
"ANTQUE SAPPHIRE": "#0F8FC0",
"AP White/ Black": "#1b151a",
"AP/ Tan": "#413838",
"APPLE": "#43B02A",
"APPLE GREEN": "#C4E4A1",
"APPLE RED": "#E5262E",
"AQUA": "#4F99C8",
"AQUA GREEN": "#34A798",
"AQUA TRIBLEND": "#84BEDF",
"AQUA/ NAVY": "#94DBED",
"AQUATIC BLUE": "#53BEE3",
"ARMY": "#5D554A",
"ARMY HEATHER": "#AEC7A9",
"ARTIC GREY": "#525C70",
"ASH": "#D7D7D7",
"ASH GREY": "#D7D7D7",
"ASH HEATHER": "#7C7E7D",
"ASH/ CHAR GREY": "#D2D6D9",
"ASH/ CHARCOAL": "#D0D3D4",
"AT ORG/ CSMIC PK": "#F69A3E",
"ATH GREY HEATHER": "#90949A",
"ATH GREY TRBLND": "#999999",
"ATH GREY TRIBLND": "#B5B3B4",
"ATH HTH/ CHR GRY": "#A8A8AA",
"ATH HTHR/ BLACK": "#000000",
"ATH HTHR/ DK GRN": "#0E582A",
"ATH HTHR/ NAVY": "#3E4353",
"ATH HTHR/ RED": "#D92737",
"ATH HTHR/ ROYAL": "#024B8F",
"ATHLETIC GOLD": "#E6B521",
"ATHLETIC GREY": "#BDBFC9",
"ATHLETIC HEATHER": "#CCCCCC",
"ATHLETIC HTHR": "#999999",
"AZUL": "#009ACE",
"Acid Green": "#7A9A01",
"Adirondack": "#0d382e",
"Admiral Duck Camo/ Black": "#32572b",
"Advantage Classic": "#64625b",
"Advantage Classic/ Brown Mesh": "#584834",
"Aerial": "#cd8b90",
"Aerial Spiral": "#cd8b90",
"All Purpose Orange": "#e25d3e",
"All Purpose/ Texas Flag": "#3a3c3a",
"All Purpose/ USA Flag": "#3a3c3a",
"Alloy Heathered": "#d0d3d7",
"Almond": "#bd9b60",
"Aloe": "#32572b",
"Alpenglow/ Navy": "#333e59",
"Alpine Green": "#244C41",
"Aluminum": "#d7dbdd",
"Aluminum Fade": "#d7dbdd",
"Aluminum/ Grey": "#d7dbdd",
"Aluminum/ Navy": "#d7dbdd",
"Amber Gold": "#DDA300",
"Amber Gold/ Navy": "#DDA300",
"American Red": "#BE0F34",
"Americus": "#1D698D",
"Anchor Slate": "#4F576E",
"Antique Gold": "#DD974A",
"Antique Gold Heather": "#FFA300",
"Apricot": "#e25d3e",
"Apricot/ Stone": "#e25d3e",
"Aqua": "#4F99C8",
"Aqua Aztec/ Black": "#7BC8D0",
"Aqua Blue": "#8ed0cf",
"Aqua Blue/ Light Lime": "#8ed0cf",
"Aqua Blue/ Navy": "#7BC8D0",
"Aqua Blue/ White": "#7BC8D0",
"Aqua Fade": "#8ed0cf",
"Aqua/ Khaki": "#7BC8D0",
"Aqua/ Stone": "#7BC8D0",
"Aquamarine/ Black": "#7BC8D0",
"Arctic": "#a192b2",
"Arctic Blue": "#c4ecf5",
"Arctic Grey": "#76767C",
"Arid": "#6c4945",
"Army": "#5D554A",
"Army Brown": "#7E7063",
"Army Camo": "#344512",
"Army Camo Dots": "#7A7256",
"Army Camo/ Black": "#51695d",
"Army Camo/ Brown/ Khaki": "#000000",
"Army Camo/ Khaki": "#51695d",
"Army Camo/ White": "#51695d",
"Army Green": "#65665C",
"Army Green/ Stone": "#51695d",
"Army Olive": "#00523e",
"Army Olive Green/ Tan": "#51695d",
"Army/ Black Buffalo": "#34443f",
"Army/ Black Zipper": "#344512",
"Aruba Blue/ Birch": "#305791",
"Ash": "#D7D7D7",
"Asphalt": "#616B6D",
"Asphalt/ Navy": "#787a81",
"Aster Blue": "#2880C1",
"Athens": "#F04E98",
"Athletic Blue": "#9FBBDE",
"Athletic Blue Tri Blend": "#6c8cb7",
"Athletic Gold": "#E6B521",
"Athletic Gold/ White": "#f5bd53",
"Athletic Grey": "#BDBFC9",
"Athletic Heather": "#CCCCCC",
"Athletic Heather/ Black": "#C1C6C8",
"Athletic Heather/ Sport Dark Navy": "#9EA2A2",
"Athletic Heather/ Sport Graphite": "#9EA2A2",
"Athletic Heather/ Sport Red": "#9EA2A2",
"Athletic Heather/ Vanilla": "#828389",
"Athletic Navy": "#161527",
"Athletic Purple": "#52458D",
"Athletic Red": "#D02130",
"Atlantic Blue": "#13409B",
"Aubergine": "#5a4769",
"Avocado": "#32572b",
"Azalea": "#FF99C0",
"Aztec": "#936520",
"Azure": "#3474a6",
"Azure Blue": "#0080D3",
"B WH/ V SM/ B WH": "#FFFFFF",
"B WH/ VN GR/ TTN": "#FFFFFF",
"B WH/ VN HTH/ WH": "#FFFFFF",
"BABY BLUE": "#82B9FF",
"BABY BLUE/ NAVY": "#82B9FF",
"BALLERINA": "#EAD3E2",
"BANANA CREAM": "#FBE69C",
"BANANA/ KEY LIME": "#FFF4B7",
"BARK": "#5D473A",
"BERRY": "#B53F66",
"BERRY TRIBLEND": "#D64C88",
"BL INK HT/ BL IN": "#353E45",
"BL SKY/ WHT/ NVY": "#D4D9DD",
"BLACK": "#000000",
"BLACK / GRAY": "#000000",
"BLACK BLIZZARD": "#101820",
"BLACK CAMO": "#000000",
"BLACK CAMO/ BLK": "#111111",
"BLACK CHERRY": "#78292C",
"BLACK DENIM": "#3F3F3F",
"BLACK DENIM/ BLK": "#2F2F2F",
"BLACK FLECK": "#101820",
"BLACK HEATHER": "#262624",
"BLACK HTH/ OXFRD": "#000000",
"BLACK HTHR/ BLK": "#474747",
"BLACK INK HEATHR": "#111820",
"BLACK INK/ WHITE": "#111820",
"BLACK MARBLE": "#000000",
"BLACK SILK": "#403E3F",
"BLACK SOLID": "#2D2926",
"BLACK TRIBLEND": "#000000",
"BLACK VEGAN LTHR": "#000000",
"BLACK/ ACID GRN": "#000000",
"BLACK/ ANTQ GOLD": "#252628",
"BLACK/ BLACK": "#000000",
"BLACK/ BROWN": "#222126",
"BLACK/ CARBON": "#27251F",
"BLACK/ CHAR HTH": "#000000",
"BLACK/ CHARCOAL": "#000000",
"BLACK/ CHRCL GRY": "#000000",
"BLACK/ CREME": "#000000",
"BLACK/ DEEP HTHR": "#000000",
"BLACK/ DK CHARCL": "#27251F",
"BLACK/ GLD GLTTR": "#000000",
"BLACK/ GOLD": "#000000",
"BLACK/ GRAPHITE": "#27251F",
"BLACK/ GRAY": "#000000",
"BLACK/ GREY": "#000000",
"BLACK/ HTHR GRAY": "#000000",
"BLACK/ HTHR GREY": "#000000",
"BLACK/ KHAKI": "#000000",
"BLACK/ MANDARIN": "#000000",
"BLACK/ ORANGE": "#000000",
"BLACK/ PURPLE": "#000000",
"BLACK/ RED": "#000000",
"BLACK/ SMKE GRY": "#25282A",
"BLACK/ SNRY YLLW": "#27251F",
"BLACK/ SP SILVER": "#000000",
"BLACK/ STONE": "#000000",
"BLACK/ TAN": "#000000",
"BLACK/ TM ORANGE": "#27251F",
"BLACK/ TURQUOISE": "#000000",
"BLACK/ VINT  WHT": "#000000",
"BLACK/ VINT CAMO": "#2C2C2C",
"BLACK/ WHITE": "#000000",
"BLACK/ WHT/ BLK": "#000000",
"BLACK/WHITE": "#101820",
"BLCK INVSBL STRP": "#38373C",
"BLCK/ CHRCL FLK": "#000000",
"BLCK/ DK CHRCOAL": "#000000",
"BLEND WHT/ TITNM": "#FFFFFF",
"BLK HTH/ D GR HT": "#27251F",
"BLK HTH/ OR SODA": "#27251F",
"BLK HTHR TRBLND": "#302F35",
"BLK HTHR TRIBLND": "#000000",
"BLK HTHR/ CARBON": "#27251F",
"BLK INK SNOW HTH": "#1D252C",
"BLK SPECKLED": "#232124",
"BLK/ BLK/ BLK": "#000000",
"BLK/ BLK/ CARBN": "#27251F",
"BLK/ CHAR BUFLO": "#000000",
"BLK/ CL RED": "#000000",
"BLK/ CMPS GOLD": "#000000",
"BLK/ DK CHRCOAL": "#27251F",
"BLK/ DK GRY HTHR": "#818283",
"BLK/ DK HTHR GRY": "#464449",
"BLK/ GR HT/ GRPH": "#27251F",
"BLK/ GRP/ CL RD": "#27251F",
"BLK/ GRP/ GRP": "#27251F",
"BLK/ NEON ORNGE": "#000000",
"BLK/ RED/ D CHRC": "#27251F",
"BLK/ S YL/ DK CH": "#27251F",
"BLK/ SFTY YELLOW": "#27251F",
"BLK/ TRU ROYAL": "#000000",
"BLK/ URBN WD/ RD": "#282629",
"BLK/ WHT/ D CHRC": "#27251F",
"BLK/ WHT/ SM GRY": "#000000",
"BLONDE": "#FCE083",
"BLRNA/ MAUVELOUS": "#EAD3E2",
"BLRNA/ WH/ W STR": "#EAD3E2",
"BLUE CHAMBRAY": "#8BA8C6",
"BLUE DENIM": "#4D5971",
"BLUE HORIZON": "#65CCEB",
"BLUE JEAN": "#596A72",
"BLUE JERRY": "#3275BA",
"BLUE MARBLE": "#4376CD",
"BLUE OCEAN": "#222737",
"BLUE SKY": "#D0E6F4",
"BLUE SPRUCE": "#4F6D5E",
"BLUE STUART": "#A41D34",
"BLUE TRIBLEND": "#687FB3",
"BLUE WOODLAND": "#456395",
"BLUE/ WHITE": "#1C57A5",
"BLUEBELL BREEZE": "#0C69AF",
"BLUEGRASS": "#609191",
"BLUSH": "#F2CFDA",
"BONDI BLUE": "#38ACC3",
"BOTTLE GREEN": "#405C50",
"BOYSENBERRY": "#79245B",
"BREEZY GRN TRBLN": "#26B4A4",
"BRICK": "#9F4D54",
"BRICK/ BLACK": "#A7123C",
"BRIGHT ORANGE": "#EB5632",
"BRIGHT YELLOW": "#F9D465",
"BROWN": "#3D2F2A",
"BROWN DUCK": "#9A7352",
"BROWN VEGAN LTHR": "#5C4738",
"BROWN/ KHAKI": "#563D36",
"BRZY GREEN TRBLN": "#26B4A4",
"BURG HTH/ OLY BL": "#572932",
"BURG/ BG H/ OL B": "#572932",
"BURGNDY/ OLY BLU": "#572932",
"BURGUNDY": "#563139",
"BURGUNDY/ TAN": "#8E4749",
"BURGUNDY/ WHITE": "#6F263D",
"BURNT ORANGE": "#FF6600",
"BUTTER": "#FAE6B5",
"Baby Blue": "#82B9FF",
"Baby Pink": "#F68FAD",
"Bahama Heathered": "#4c6a93",
"Balsam Green": "#576664",
"Baltic": "#000000",
"Bamboo Blackout": "#819E87",
"Bark": "#5D473A",
"Bark Duck Camo/ Brown": "#32572b",
"Basil": "#596c62",
"Beach Blue": "#0047ab",
"Beach Glass": "#96DFCE",
"Beach Orange": "#ffa500",
"Beer & Hops": "#ffffff",
"Beetle/ Quarry": "#000000",
"Beige": "#CCBCAD",
"Bel Air Blue": "#615D90",
"Bermuda": "#1D698D",
"Bermuda Blackout": "#41748d",
"Berry Tri Blend": "#480b1d",
"Biking Red": "#d51d36",
"Bimini Blue": "#63abd6",
"Bimini Blue/ Peach": "#63a6d6",
"Birch": "#605951",
"Birch/ Black": "#605951",
"Birch/ Brown/ Loden": "#605951",
"Biscuit/ Black": "#000000",
"Black": "#000000",
"Black - B120": "#000000",
"Black / Black Leopard/ Black": "#1b151a",
"Black Aqua": "#223456",
"Black Camo": "#000000",
"Black Camo Heather": "#000000",
"Black Camo/ Black": "#1b151a",
"Black Cheetah": "#1b1d1e",
"Black Crystal": "#2d333c",
"Black Denim": "#3F3F3F",
"Black Heather": "#262624",
"Black Heather/ Black": "#000000",
"Black Heather/ White": "#1b151a",
"Black Ink": "#111820",
"Black Ink Heather": "#000000",
"Black Jordan Plaid": "#000000",
"Black Leopard": "#1b151a",
"Black Leopard Triblend": "#3D3935",
"Black Leopard/ Black": "#000000",
"Black Melange": "#0f1313",
"Black Mineral Wash": "#2d333c",
"Black Rainbow": "#000000",
"Black Rainbow Cut-Spiral": "#2d333c",
"Black Reptile": "#25282a",
"Black Solid": "#2D2926",
"Black Tie Dye": "#3D3935",
"Black Tonal Blend": "#1b211f",
"Black Triblend": "#000000",
"Black Woodland Camo": "#000000",
"Black Z - Quilted": "#1b151a",
"Black/ Army Camo/ Khaki": "#B9975B",
"Black/ Birch": "#000000",
"Black/ Black": "#000000",
"Black/ Black Leopard": "#1b151a",
"Black/ Black Leopard/ Black": "#1b151a",
"Black/ Black Rope": "#000000",
"Black/ Black to White Fade": "#000000",
"Black/ Black/ Black": "#000000",
"Black/ Black/ Fleur De Lis": "#000000",
"Black/ Black/ Skull": "#000000",
"Black/ Black/ White": "#000000",
"Black/ Blaze AP": "#1b151a",
"Black/ Brown": "#222126",
"Black/ Camel/ Grey": "#000000",
"Black/ Camo": "#000000",
"Black/ Camo/ Loden": "#1b151a",
"Black/ Camo/ Stone": "#000000",
"Black/ Caramel/ Dark Grey": "#000000",
"Black/ Carbon": "#27251F",
"Black/ Carbon Heather": "#000000",
"Black/ Cardinal/ Khaki": "#000000",
"Black/ Cardinal/ Stone": "#000000",
"Black/ Charcoal": "#000000",
"Black/ Charcoal Heather": "#FFFFFF",
"Black/ Charcoal Split": "#1b151a",
"Black/ Charcoal/ Black": "#000000",
"Black/ Checker Strap": "#1b1d1e",
"Black/ Columbia": "#2d333c",
"Black/ Cow/ White": "#000000",
"Black/ Dark Charcoal": "#000000",
"Black/ Dark Grey": "#000000",
"Black/ Dark Grey/ Silver": "#000000",
"Black/ Dark Heather Grey": "#000000",
"Black/ Deep Orange": "#000000",
"Black/ Deep Orange/ White": "#000000",
"Black/ Ecru Buffalo Plaid": "#2C282C",
"Black/ Floral/ Khaki": "#1b151a",
"Black/ Fog": "#000000",
"Black/ Forest Camo": "#1b1d1e",
"Black/ Gold": "#000000",
"Black/ Gold/ White": "#000000",
"Black/ Graphite": "#27251F",
"Black/ Green/ Khaki": "#284734",
"Black/ Grey": "#000000",
"Black/ Grey/ White": "#1b151a",
"Black/ Gunmetal Heather": "#1b1d1e",
"Black/ Heather": "#000000",
"Black/ Heather Grey": "#1b151a",
"Black/ Heather Grey/ White": "#000000",
"Black/ Khaki": "#000000",
"Black/ Leopard": "#000000",
"Black/ Leopard/ Khaki": "#000000",
"Black/ Light Charcoal": "#414955",
"Black/ Light Olive": "#000000",
"Black/ Lime": "#000000",
"Black/ Lime - B200": "#000000",
"Black/ Melange Black": "#000000",
"Black/ Natural": "#292A2E",
"Black/ Natural/ Light Grey": "#1c1b19",
"Black/ Neon Blaze": "#000000",
"Black/ Neon Pink": "#1b151a",
"Black/ Neon Yellow": "#000000",
"Black/ Orange": "#000000",
"Black/ Orange/ Khaki": "#000000",
"Black/ Orange/ White Plaid": "#000000",
"Black/ Oxford": "#2C282C",
"Black/ Rainbow": "#2d333c",
"Black/ Realtree AP": "#1b151a",
"Black/ Realtree Hardwood": "#3a3c3a",
"Black/ Red": "#000000",
"Black/ Red Crystal": "#2d333c",
"Black/ Red/ White": "#0d1013",
"Black/ Royal Blue": "#1a1618",
"Black/ Safety Orange": "#000000",
"Black/ Scarlet Red/ Khaki": "#000000",
"Black/ Silver": "#000000",
"Black/ Stone": "#000000",
"Black/ Stone Stitch": "#1b151a",
"Black/ Sunray Yellow": "#000000",
"Black/ Swirl": "#1b151a",
"Black/ Teal": "#2d333c",
"Black/ Team Orange": "#000000",
"Black/ True Red": "#000000",
"Black/ True Red/ White": "#000000",
"Black/ True Royal": "#000000",
"Black/ USA": "#1b151a",
"Black/ USA Flag": "#000000",
"Black/ USA Mesh": "#1b151a",
"Black/ Vanilla": "#262228",
"Black/ Vegas Gold/ Fleur De Lis": "#000000",
"Black/ Vintage Red/ Khaki": "#2E2926",
"Black/ White": "#000000",
"Black/ White Polka Dots": "#000000",
"Black/ White Split": "#000000",
"Black/ White Stripe": "#1b1d1e",
"Black/ White/ Dark Heather": "#000000",
"Black/ White/ Deep Orange": "#000000",
"Black/ White/ Forest": "#000000",
"Black/ White/ Gold": "#000000",
"Black/ White/ Grey/ Red": "#1b151a",
"Black/ White/ Red": "#000000",
"Black/ White/ Royal": "#000000",
"Black/ White/ White": "#000000",
"Black/ Yellow/ Khaki": "#000000",
"Black/ Zebra/ White": "#000000",
"Blaze": "#AC1124",
"Blaze Duck Camo/ Blaze": "#32572b",
"Blaze Mesh": "#f2724d",
"Blaze Orange": "#f2724d",
"Blaze Orange - Buck": "#f2724d",
"Blaze Orange - Quail": "#f2724d",
"Blaze Realtree AP": "#E24C29",
"Blaze Realtree AP/ Black": "#f2724d",
"Blaze/ Realtree Hardwoods": "#f2724d",
"Blaze/ XTRA": "#E24C29",
"Blended Black": "#040000",
"Blended White": "#ffffff",
"Blizzard Duck Camo/ White": "#e3e7ed",
"Blue": "#3157A2",
"Blue Aqua Fade": "#8fb1dc",
"Blue Camo/ Black": "#3474a6",
"Blue Chambray": "#8BA8C6",
"Blue Coast": "#3474a6",
"Blue Denim/ Khaki": "#5B7F95",
"Blue Dusk": "#1D303F",
"Blue Frost": "#B0C0D6",
"Blue Gobi": "#ffffff",
"Blue Hawaiian": "#ffffff",
"Blue Hawaiin": "#ffffff",
"Blue Ice": "#7D9FBB",
"Blue Jean": "#596A72",
"Blue Jerry": "#3275BA",
"Blue Magic": "#0077C0",
"Blue Mist": "#8fb1dc",
"Blue Mist Fade": "#8fb1dc",
"Blue Mist/ Light Teal": "#8fb1dc",
"Blue Ocean": "#222737",
"Blue Pines": "#333e59",
"Blue Seersucker": "#9cbfe2",
"Blue Steel": "#5B7F95",
"Blue Steel/ Grey": "#3474a6",
"Blue Stripe/ Khaki": "#333e59",
"Blue Taffy": "#3474a6",
"Blue Teal/ Birch/ Navy": "#439AAB",
"Blue Tide": "#1D698D",
"Blue Water": "#0077CF",
"Blue Wave": "#0047ab",
"Blue Waves": "#3474a6",
"Blue/ Black": "#123694",
"Blue/ Charcoal Microcheck": "#333e59",
"Blue/ White": "#1C57A5",
"Blueberry": "#68ACE5",
"Blush": "#F2CFDA",
"Blush Pink": "#DFBBB0",
"Blush/ White Zipper": "#EED3D0",
"Bone": "#EEEADF",
"Bora Bora": "#1D698D",
"Bottle": "#034638",
"Bottle Green": "#405C50",
"Bottle Green/ Stone": "#32572b",
"Bottomland": "#766855",
"Breaker Blue": "#5D7079",
"Breaker Blue/ Navy": "#5D7079",
"Breaker Blue/ Stone": "#5D7079",
"Breaker Blue/ White": "#95C1C9",
"Breakup/ Breakup": "#3a3c3a",
"Breeze": "#B1E4E3",
"Brick": "#9F4D54",
"Brick Red": "#B10F3B",
"Brick Red/ Oxford Heather": "#8A2232",
"Bright Pink": "#F04E98",
"Bright White": "#FFFFFF",
"Bronze Green": "#5f5f49",
"Bronze/ Pine Green": "#DDA300",
"Brown": "#3D2F2A",
"Brown Camo Blotch": "#B9975B",
"Brown Duck": "#9A7352",
"Brown Heather": "#4a342b",
"Brown Savana": "#9F877B",
"Brown Waxy Canvas": "#6b4a35",
"Brown Z - Quilted": "#6b4a35",
"Brown/ Camo": "#6b4a35",
"Brown/ Desert Camo": "#6b4a35",
"Brown/ Khaki": "#563D36",
"Brown/ Realtree AP": "#6b4a35",
"Brown/ Sand": "#6b4a35",
"Brown/ Stone": "#6b4a35",
"Brown/ Stone Stitch": "#6b4a35",
"Brushed Black": "#1b151a",
"Brushed Charcoal": "#4d464d",
"Brushed Dark Olive Green": "#616545",
"Brushed Navy": "#333e59",
"Buckthorn Brown": "#6b4a35",
"Buckthorn Brown/ Black": "#6b4a35",
"Buckthorn Brown/ Black/ Stone": "#6b4a35",
"Buckthorn Brown/ White": "#6b4a35",
"Burgundy": "#563139",
"Burgundy Heather": "#582005",
"Burgundy Melange": "#4d1e24",
"Burgundy/ Grey": "#4d1e24",
"Burgundy/ Khaki": "#4d1e24",
"Burgundy/ White": "#6F263D",
"Burnt Orange": "#FF6600",
"Burnt Orange Heather": "#d3440d",
"Burnt Orange Tonal Blend": "#d3440d",
"Burnt Orange White": "#d3440d",
"Burnt Orange/ Graphite": "#d3440d",
"Burnt Orange/ White": "#D3440D",
"Butter": "#FAE6B5",
"C BL/ WHT/ C BLU": "#92B5D9",
"CACTUS": "#5B6F55",
"CACTUS GREEN": "#ACBB78",
"CALIFORNIA BLUE": "#0091B3",
"CAMEL/ NAVY": "#AF6D04",
"CAMO": "#3F3327",
"CAMOUFLAGE GREEN": "#454634",
"CAMOUFLAGE SAND": "#AC9D73",
"CAMP ORNGE/ CRBN": "#DC4405",
"CAMPUS GOLD": "#ECB719",
"CAMPUS PURPLE": "#613081",
"CANCUN": "#91ECFA",
"CANDY ORANGE": "#F5A688",
"CARBN BLU SNW HT": "#4EC3E0",
"CARBON": "#4B4F54",
"CARBON HEATHER": "#5D5E62",
"CARBON HTHR/ BLK": "#4B4F54",
"CARBON/ ACD GRN": "#4B4F54",
"CARBON/ BLACK": "#4B4F54",
"CARBON/ OLY RED": "#2C2C31",
"CARD BLCK TRBLND": "#A03837",
"CARDINAL": "#C03545",
"CARDINAL HEATHER": "#A24040",
"CARDINAL RED": "#C03545",
"CARDINAL TRBIBLD": "#6C122F",
"CARIB BL HTH/ OX": "#44BAD6",
"CARIB BLUE/ D GR": "#1F82BD",
"CARIBBEAN BLUE": "#00A7D4",
"CARIBBEAN MLANGE": "#B3DFE2",
"CARIBBEAN/ WHITE": "#78D5E1",
"CARMINE RED TRBL": "#9C2022",
"CAROLINA BLUE": "#6299DD",
"CAYENNE": "#91383E",
"CEM/ OCEANBRY": "#BDBDBF",
"CEMENT": "#C7C2C9",
"CEMENT/ DK SMOKE": "#BDBDBF",
"CEMENT/ VERY BRY": "#BDBDBF",
"CEMENT/ WILDBRRY": "#BDBDBF",
"CHAMBRAY": "#BDD6E6",
"CHAMPAGNE": "#D8C8C3",
"CHAR BLACK TRIB": "#827F77",
"CHAR BLK TRIBLND": "#827F77",
"CHAR FLK/ BLACK": "#A5A2A3",
"CHAR HTH/ BL INK": "#5B6670",
"CHAR-BLACK TRIB": "#303030",
"CHAR-BLK TRIBLND": "#424244",
"CHAR-BLK TRIBND": "#827F77",
"CHAR/ FIRE CORAL": "#484848",
"CHARCL SNOW HTH": "#5B6670",
"CHARCL/ DK CHRCL": "#827F77",
"CHARCOAL": "#827F77",
"CHARCOAL FLECK": "#707073",
"CHARCOAL GRAY": "#827F77",
"CHARCOAL GREY": "#54565B",
"CHARCOAL HEATHER": "#827F77",
"CHARCOAL HTHR": "#434345",
"CHARCOAL HTR": "#827F77",
"CHARCOAL MARBLE": "#494849",
"CHARCOAL TRBLND": "#706E72",
"CHARCOAL/ BALRNA": "#4E4B48",
"CHARCOAL/ BLACK": "#6E686C",
"CHARCOAL/ NAVY": "#53565A",
"CHARCOAL/ WHITE": "#606266",
"CHARCOL FLK/ BLK": "#707073",
"CHARISMA CORAL": "#FF818D",
"CHARITY PINK": "#F8B4BE",
"CHILI": "#8D3E44",
"CHILI/ BLGRS/ KH": "#7C2128",
"CHILI/ BROWN": "#AA3756",
"CHILL": "#88DBDF",
"CHILL/ INDIGO": "#AADADC",
"CHR FLK/ ELEC BL": "#707073",
"CHR FLK/ EMERALD": "#707073",
"CHR FLK/ FIRE CR": "#484848",
"CHRCL BLCK TRBLN": "#4D5154",
"CHRCL BLK SLUB": "#000000",
"CHRCL FLK/ BLCK": "#707073",
"CHRCL FLK/ WHITE": "#707073",
"CHRCL/ BLK/ BLK": "#35383F",
"CHRCL/ NEON BLUE": "#626262",
"CHRCL/ NEON PINK": "#626262",
"CHRCL/ RL TREE X": "#38383A",
"CHRCOAL BLK SLUB": "#494849",
"CHRL HTR/ VNT WH": "#827F77",
"CIEL BLUE": "#7BA4DB",
"CILANTRO": "#A39E8C",
"CILNTRO/ STN/ KH": "#A39E8C",
"CITRINE": "#F6ECBF",
"CITY GREEN": "#40513A",
"CLASC NAVY/ CRBN": "#1F273F",
"CLASSC NVY/ CRBN": "#1F2A44",
"CLASSC RED/ CRBN": "#9D2235",
"CLASSIC DENIM": "#242D4A",
"CLASSIC NAVY": "#1F273F",
"CLASSIC ORANGE": "#F9562D",
"CLASSIC PINK": "#EABDD3",
"CLASSIC RED": "#A3262C",
"CLASSIC RED/ BLK": "#A3262C",
"CLAY": "#CB8484",
"CLAY TRIBLEND": "#B55851",
"CLEAN MINT": "#93CDBE",
"CLEAR": "#EBEDEB",
"CLOUD BLUE": "#7FA1B1",
"CLOUD BLUE/ CREM": "#7FA1B1",
"CLOVER": "#397556",
"CLSC NVY HT/ CRB": "#1F2A44",
"COAL PIGMENT": "#706B65",
"COBALT": "#2445AB",
"COCOA": "#4E3428",
"COFFEE": "#4A3C31",
"COLMBIA BLU HTHR": "#7AA9E3",
"COLUMB BLUE/ WHT": "#7AA9E3",
"COLUMBIA BLUE": "#3B6CA6",
"CONCRETE": "#B8B8BA",
"CONCRETE GRAY": "#BDB4AF",
"CONCRETE/ BROWN": "#A7A29F",
"COOL BLUE": "#34558B",
"COOL GREY": "#8B8B84",
"COOL RYL TRIBLD": "#5B98F3",
"COPPER": "#C16A3D",
"CORAL": "#FE9B71",
"CORAL CRAZE": "#FE8E9E",
"CORAL SILK": "#FF777F",
"CORAL/ TAN": "#D57E77",
"COTTON CANDY": "#89C8D7",
"CRANBERRY": "#9B0032",
"CRBN/ BLK H/ BLK": "#4B4F54",
"CRBN/ ORNG SODA": "#3D3C44",
"CRD BLK/ BLK TRB": "#B2454A",
"CREAM": "#F2E3BB",
"CREAM FLECK": "#EEEAE3",
"CREAM TRIBLEND": "#EFECDD",
"CREAM/ BLCK TRIB": "#EEEAE3",
"CREAM/ NAVY TRIB": "#EEEAE3",
"CREME": "#E5DBBA",
"CRIMSON": "#8A2432",
"CRIMSON FALL": "#BE2A45",
"CRM/ CRD BLK TRB": "#EFECDD",
"CROWN RASPBERRY": "#CF035C",
"CRUNCHBERRY": "#EF4A81",
"CRYSTAL BLUE": "#B6C8E0",
"CRYSTAL QUARTZ": "#E6E3DE",
"CURRANT": "#4D1925",
"CYBER PINK": "#FB4788",
"CYPRESS GREEN": "#516C63",
"CYPRESS/ BROWN": "#7A8E8C",
"Cactus": "#5B6F55",
"Cactus Flower Heather": "#FFFFFF",
"Cairo": "#2d333c",
"California Blue": "#0091B3",
"Calm Pink": "#f4d2d9",
"Calm Waters/ Navy/ Khaki": "#333e59",
"Camel": "#B48148",
"Camel Corduroy": "#B48148",
"Camel/ Brown": "#6b4a35",
"Camo": "#3F3327",
"Camo Green": "#8d7453",
"Camo/ Black": "#000000",
"Camo/ Green": "#8d7453",
"Campus Gold": "#ECB719",
"Campus Orange": "#E55335",
"Campus Purple": "#613081",
"Cantaloupe": "#EE9572",
"Canyon": "#cd8b90",
"Capri": "#4AC9E3",
"Caramel": "#85461E",
"Caramel/ Black": "#DC8649",
"Caramel/ Dark Grey": "#6b4a35",
"Caramel/ White": "#E7CEB5",
"Carbon": "#4B4F54",
"Carbon Heather": "#5D5E62",
"Carbon/ Black": "#4B4F54",
"Carbon/ Carbon": "#66676C",
"Carbon/ Carbon Heather": "#66676C",
"Carbon/ Classic Navy Heather": "#66676C",
"Cardinal": "#C03545",
"Cardinal Blackout": "#64181f",
"Cardinal Red": "#C03545",
"Cardinal Tri Blend": "#8A1538",
"Cardinal/ Black/ Khaki": "#8a1b33",
"Cardinal/ Black/ White": "#8a1b33",
"Cardinal/ Gold": "#8a1b33",
"Cardinal/ Khaki": "#8a1b33",
"Cardinal/ Stone": "#8a1b33",
"Cardinal/ White": "#63012c",
"Caribbean": "#78D5E1",
"Caribbean Blue/ White": "#00A9CE",
"Caribbean Mist": "#5CB8B2",
"Carmel/ Birch": "#B48148",
"Carmel/ Black": "#B48148",
"Carolina Blue": "#6299DD",
"Carolina Heather": "#7D9BC1",
"Cashmere Blue/ Floral": "#3474a6",
"Caspian": "#1D698D",
"Castlerock": "#434854",
"Cayenne": "#91383E",
"Cedar Green Heather": "#5E6737",
"Ceil Blue": "#b8ccea",
"Celery Juice": "#d1ebb4",
"Cement": "#C7C2C9",
"Cerulean Blue": "#167378",
"Chairlift/ Black": "#1b151a",
"Chalky Mint": "#9EEACE",
"Chambray": "#BDD6E6",
"Champ": "#1D698D",
"Charcoal": "#827F77",
"Charcoal Grey": "#54565B",
"Charcoal Heather": "#827F77",
"Charcoal Heather/ Army Heather": "#2A2A2A",
"Charcoal Heather/ Black": "#2A2A2A",
"Charcoal Heather/ Burgundy Heather": "#2A2A2A",
"Charcoal Heather/ White": "#48464A",
"Charcoal Heathered": "#5C5D5B",
"Charcoal Melange": "#545859",
"Charcoal Mesh": "#4d464d",
"Charcoal Slub/ Black": "#4d464d",
"Charcoal/ Black": "#6E686C",
"Charcoal/ Black Buffalo": "#48464A",
"Charcoal/ Black Rope": "#4d464d",
"Charcoal/ Black Split": "#4d464d",
"Charcoal/ Black/ Black": "#4d464d",
"Charcoal/ Black/ White": "#4d464d",
"Charcoal/ Burnt Orange/ Black": "#3a3c3a",
"Charcoal/ Cyan": "#8a9b9e",
"Charcoal/ Fireball Red": "#363840",
"Charcoal/ Fog": "#3a3c3a",
"Charcoal/ Grey": "#54585A",
"Charcoal/ Ice Grey": "#4d464d",
"Charcoal/ Khaki": "#54585A",
"Charcoal/ Neon Blue": "#8a9b9e",
"Charcoal/ Neon Green": "#4d464d",
"Charcoal/ Neon Orange": "#4d464d",
"Charcoal/ Neon Pink": "#4d464d",
"Charcoal/ Neon Yellow": "#4d464d",
"Charcoal/ Old Gold": "#8a9b9e",
"Charcoal/ Red": "#4f4e46",
"Charcoal/ Royal": "#363840",
"Charcoal/ Stone": "#4d464d",
"Charcoal/ White": "#606266",
"Charcoal/ White Split": "#8a9b9e",
"Charcoal/ Yellow": "#363840",
"Charity Pink": "#F8B4BE",
"Cheetah": "#c3a886",
"Chelsea Grey": "#969295",
"Cherry Red": "#951C33",
"Chestnut": "#7A6855",
"Chill": "#88DBDF",
"Chino": "#c2b4a6",
"Chino Black": "#1b151a",
"Chino Black Duck Camo/ Black": "#1b151a",
"Chino Black/ White": "#1b151a",
"Chino Blue": "#3474a6",
"Chino Cardinal/ White": "#8a1b33",
"Chino Charcoal": "#4d464d",
"Chino Charcoal/ Black": "#4d464d",
"Chino Dark Brown": "#41392d",
"Chino Dark Olive Green": "#5d5d3d",
"Chino Duck Camo/ White": "#584834",
"Chino Forest Green": "#09322f",
"Chino Forest Green/ White": "#32572b",
"Chino Grey": "#848283",
"Chino Grey/ Black": "#64625b",
"Chino Khaki": "#B59F88",
"Chino Khaki/ Black": "#B59F88",
"Chino Maroon/ Black": "#5d1d2a",
"Chino Navy": "#333e59",
"Chino Navy/ White": "#333e59",
"Chino Orange/ White": "#e25d3e",
"Chino Red": "#b62730",
"Chino Red/ White": "#b62730",
"Chino Royal": "#305791",
"Chino Royal/ White": "#305791",
"Chino Sky Blue/ White": "#71B2C9",
"Chino Stone": "#E1D9C5",
"Chino Stone/ Navy": "#DBD8CF",
"Chino Texas Orange": "#c16c4b",
"Chino Vegas Gold/ Black": "#ddb063",
"Chino White": "#e3e7ed",
"Chino White/ Navy": "#e3e7ed",
"Chocolate": "#4E2A28",
"Chocolate Chip/ Birch": "#6b4a35",
"Chocolate Chip/ Grey Brown": "#614431",
"Chocolate Floral/ Black": "#83635C",
"Chocolate/ Fawn": "#83635C",
"Chocolate/ Fawn/ Khaki": "#83635C",
"Chocolate/ Natural/ Khaki": "#6b4a35",
"Chocolate/ Tonal Fawn/ Chocolate": "#83635C",
"Cider": "#9e6a37",
"Cinder": "#989BA0",
"Cinnamon Red": "#ee344b",
"Cinnamon Red/ Olive Green/ Stone": "#ee344b",
"Classic Khaki": "#E9DFC5",
"Classic Navy": "#1F273F",
"Classic Navy Heather": "#02284B",
"Classic Navy Heather/ Carbon": "#263147",
"Classic Navy/ Carbon": "#193047",
"Classic Navy/ Classic Navy": "#263147",
"Classic Navy/ Classic Navy Heather": "#263147",
"Classic Navy/ Gunmetal Heather": "#032E54",
"Classic Navy/ Red": "#032E54",
"Classic Navy/ True Royal": "#263147",
"Classic Navy/ White": "#263147",
"Classic Rainbow": "#1D698D",
"Classic Rainbow Spiral": "#13638c",
"Classic Red": "#A3262C",
"Classic Red/ Carbon": "#BA0C2F",
"Classic Red/ Carbon Heather": "#BA0C2F",
"Clay": "#CB8484",
"Clean Green": "#007c55",
"Clear": "#EBEDEB",
"Cloud": "#FFFFFF",
"Cloud Black": "#000000",
"Cloud Blue": "#7FA1B1",
"Cloud Heather": "#D2D6D9",
"Cloud Purple": "#464E7E",
"Cloud Rock": "#63666A",
"Cloudy Blue": "#00a8dd",
"Cloudy Sky Crystal": "#0056A4",
"Club Blue": "#4f91cc",
"Coal": "#64625b",
"Cobalt": "#2445AB",
"Cobalt Blue/ Grey": "#305791",
"Cobalt Blue/ White": "#0047ab",
"Coconut Milk": "#737470",
"Coffee/ Claret": "#413838",
"Collection Blue": "#B0C0D6",
"Collegiate Blue": "#2E62A3",
"Collegiate Blue/ Blue/ Black": "#2E62A3",
"Colony Blue": "#69B3E7",
"Columbia": "#52ADD8",
"Columbia Blue": "#3B6CA6",
"Columbia Blue Tonal Blend": "#61a3d4",
"Columbia Blue/ Charcoal/ Navy": "#5b9ce4",
"Columbia Blue/ Graphite": "#4fabff",
"Columbia Blue/ Khaki": "#5b9ce4",
"Columbia Blue/ White": "#4fabff",
"Concrete Grey": "#726d71",
"Copper": "#C16A3D",
"Copper Crystal": "#A0522D",
"Copper Slub/ Black": "#8D6947",
"Coral": "#FE9B71",
"Coral Dream": "#e3717c",
"Coral/ White": "#E07883",
"Cosmic Pink": "#CE0F69",
"Cosmos": "#000000",
"Cotton Candy": "#89C8D7",
"Country DNA": "#6b5742",
"Country DNA/ USA Flag": "#8d7453",
"Coyote": "#c3ad8b",
"Coyote Brown": "#8B7C5E",
"Cream": "#F2E3BB",
"Cream/ Black": "#F1F1DE",
"Cream/ Caramel": "#ddd5c1",
"Cream/ Dark Green": "#F1F1DE",
"Cream/ Green/ Black": "#ddd5c1",
"Cream/ Light Denim": "#F1F1DE",
"Cream/ Loden Green/ Dark Orange": "#ddd5c1",
"Cream/ Mocha": "#ddd5c1",
"Cream/ Navy": "#F1F1DE",
"Cream/ Red": "#F1F1DE",
"Cream/ Wheat": "#F1F1DE",
"Creamsicle Pink/ White": "#fcdfe2",
"Crimson": "#8A2432",
"Crimson Heather": "#d32039",
"Crystal Baby Blue": "#BDD6E6",
"Crystal Black": "#25282A",
"Crystal Ice Blue": "#69B3E7",
"Crystal Navy": "#012943",
"Crystal Navy/ Columbia": "#012943",
"Crystal Red/ Black": "#BA0C2F",
"Crystal Royal": "#0057b8",
"Crystal Silver": "#c5c5c5",
"Crystal Teal/ Black": "#B1E4E3",
"Currant": "#4D1925",
"Cyan/ Black": "#00FFFF",
"Cyber Pink": "#FB4788",
"Cypress Green": "#516C63",
"D CH/ D GRN/ BLK": "#4B4F54",
"D NV/ T RY/ D CH": "#242C43",
"DARK ASH": "#A2A6A6",
"DARK CAMO": "#3F3327",
"DARK CHARCOAL": "#535760",
"DARK CHOCOLATE": "#665542",
"DARK DENIM": "#0F478D",
"DARK GRAY": "#666666",
"DARK GREEN": "#265142",
"DARK GREY": "#8E8E8E",
"DARK GREY HEATHR": "#59585D",
"DARK GREY/BLACK": "#575652",
"DARK GRY HEATHER": "#404144",
"DARK GRY HTHR": "#404144",
"DARK HEATHER": "#676769",
"DARK HEATHR GREY": "#59595B",
"DARK HTHR GRAY": "#B3B4B6",
"DARK KHAKI": "#D5CB9F",
"DARK NAVY": "#2F3847",
"DARK OXFORD": "#363A51",
"DARK PLUM": "#6C444C",
"DARK SMOKE": "#57585C",
"DARK TEAL": "#174A5B",
"DEEP BLUE": "#384059",
"DEEP FOREST": "#1A3024",
"DEEP FORTE": "#8B8DC9",
"DEEP FORTE BLUE": "#6686DB",
"DEEP HEATHER": "#707070",
"DEEP HEATHR/ BLK": "#70787B",
"DEEP HTH/ CARDNL": "#A1364A",
"DEEP HTHR/ BLACK": "#404144",
"DEEP HTR/ DP HTR": "#656F70",
"DEEP NAVY": "#003049",
"DEEP NAVY/ BROWN": "#445060",
"DEEP PURPLE": "#4B384C",
"DEEP RED": "#AD3129",
"DEEP ROYAL": "#293B7B",
"DEEP VIOLET": "#443264",
"DENIM": "#5881B4",
"DENIM BLUE": "#5881B4",
"DENIM BLUE/ WHT": "#152642",
"DENIM HEATHER": "#6F82A0",
"DENIM SNOW HTHR": "#4D5F80",
"DENIM/ BROWN": "#6682A9",
"DESERT": "#CFAD88",
"DESERT CAMO": "#C7B798",
"DESERT KHAKI": "#A09074",
"DESERT PINK": "#D4A299",
"DESERT ROSE": "#E9E7E8",
"DIGIAL CAMO RED": "#B0282D",
"DIGITAL CAMO ROY": "#335BA4",
"DILL": "#8AAE93",
"DK BLUE PIGMNT": "#5E748B",
"DK GREY HEATHER": "#444343",
"DK GREY HTH/ BLK": "#8C8985",
"DK GREY HTHR": "#6C6F70",
"DK GRY HEATHER": "#404144",
"DK HEATHER GREY": "#2D2E33",
"DK NAVY/ DK CHRC": "#242C43",
"DK SMOKE/ DK SMK": "#454647",
"DP HEATHER/ BLK": "#87878A",
"DP HEATHER/ NAVY": "#87878A",
"DP HT/ DK GRY HT": "#404144",
"DRK GREY HEATHER": "#6C6F70",
"DRK GRY HTR/ BLK": "#605A61",
"DRK HEATHER GRAY": "#7E7E7E",
"DRK HTHR/ BLACK": "#66686A",
"DRK HTHR/ RED": "#66686A",
"DUCK BROWN": "#835D32",
"DUSTY BLU TRBLND": "#ABC1BE",
"DUSTY BLUE": "#ADC4BC",
"DYNASTY GRN STRP": "#008578",
"Daffodil": "#F0DD9D",
"Daisy": "#F9F46F",
"Daisy Mist": "#FBDD7A",
"Dark Blue": "#112154",
"Dark Blue/ White": "#002F6C",
"Dark Brown": "#524331",
"Dark Charcoal": "#535760",
"Dark Denim": "#0F478D",
"Dark Green": "#265142",
"Dark Green Heather": "#274a39",
"Dark Green/ Black": "#00523e",
"Dark Green/ Black/ White": "#00523e",
"Dark Green/ Camel/ Brown": "#00523e",
"Dark Green/ Gold": "#00523e",
"Dark Green/ Grey": "#00523e",
"Dark Green/ Khaki": "#32572b",
"Dark Green/ Red/ Mexico Flag": "#00523e",
"Dark Green/ Stone": "#00523e",
"Dark Green/ White": "#00523e",
"Dark Grey": "#8E8E8E",
"Dark Grey Corduroy/ Black": "#737470",
"Dark Grey Heather": "#494d54",
"Dark Grey Heather/ Black": "#66676C",
"Dark Grey/ Black": "#727272",
"Dark Grey/ Columbia Blue": "#63666A",
"Dark Grey/ Dark Grey": "#737470",
"Dark Grey/ Navy": "#737470",
"Dark Grey/ Neon Orange": "#a9a9a9",
"Dark Grey/ Red": "#737470",
"Dark Grey/ Royal": "#737470",
"Dark Grey/ White": "#737470",
"Dark Heather": "#676769",
"Dark Heather Grey": "#64625b",
"Dark Heather Grey/ Black": "#555050",
"Dark Heather Grey/ Navy": "#64625b",
"Dark Heather Grey/ Red": "#64625b",
"Dark Khaki": "#D5CB9F",
"Dark Khaki Plaid": "#d1cec5",
"Dark Lavender": "#A194C2",
"Dark Loden/ Jaffa Orange": "#175344",
"Dark Maroon": "#5d1d2a",
"Dark Maroon/ Khaki": "#572932",
"Dark Maroon/ Stone": "#5d1d2a",
"Dark Mocha": "#56432e",
"Dark Navy": "#2F3847",
"Dark Navy/ Dark Charcoal": "#28283d",
"Dark Navy/ Floral": "#333e59",
"Dark Navy/ Light Navy": "#333e59",
"Dark Navy/ Navy": "#333e59",
"Dark Olive Green Camo/ Black": "#616545",
"Dark Olive Green/ Khaki": "#00523e",
"Dark Olive Green/ White": "#616545",
"Dark Olive Heathered": "#626a51",
"Dark Orange/ Birch/ Patriot Blue": "#e25d3e",
"Dark Orange/ Black": "#e25d3e",
"Dark Oxford": "#363A51",
"Dark Pewter": "#404348",
"Dark Pink": "#ffbdc5",
"Dark Pink/ Khaki": "#d63888",
"Dark Smoke": "#57585C",
"Dark Tan/ Navy": "#c8af93",
"Dayglo": "#cd8b90",
"Deadwood Tree Camo": "#B0B7BC",
"Deep Blue": "#384059",
"Deep Blue Heather": "#1e3a73",
"Deep Forest": "#1A3024",
"Deep Forte Blue": "#6686DB",
"Deep Heather": "#707070",
"Deep Navy": "#003049",
"Deep Navy/ Khaki": "#333e59",
"Deep Orange": "#d95917",
"Deep Purple": "#4B384C",
"Deep Red": "#AD3129",
"Deep Royal": "#293B7B",
"Denali": "#A5B3CC",
"Denali Olive Green/ Grey": "#b1aca8",
"Denim": "#5881B4",
"Denim Blue": "#5881B4",
"Denim Tri Blend": "#325064",
"Denim/ Khaki": "#305791",
"Desert": "#CFAD88",
"Desert Camo/ Brown": "#32572b",
"Desert Pink": "#D4A299",
"Desert Rose": "#E9E7E8",
"Devine": "#cd8b90",
"Digital Camo/ Light Green": "#32572b",
"Dijon/ Black": "#c68a32",
"Dill": "#8AAE93",
"Dragonfruit": "#9688AC",
"Driftwood": "#B59F88",
"Driftwood/ Khaki": "#B59F88",
"Duck Brown": "#835D32",
"Dunes": "#ffffff",
"Dusk": "#012943",
"Dusk Orchid": "#C45B7A",
"Dust": "#D1D3D1",
"Dusty Pink": "#fbd6e1",
"Dusty Pink/ Floral": "#c0869b",
"Dusty Pink/ Pink/ Peachy Pink/ Butterfly": "#ffbdc5",
"Dusty Rose": "#EFC0B8",
"Dusty Rose Corduroy": "#C48490",
"Dusty Rose Tie Dye": "#f0b8c0",
"Dusty Rose/ Grey": "#C48490",
"Dusty Rose/ White": "#C48490",
"Dynamo Grey": "#969a9c",
"EARTH COAL": "#3E3A3B",
"EARTH GREY": "#DDD8D4",
"EARTH OCEAN": "#7C848A",
"EARTH WHITE": "#FAF8F9",
"EC GRY/ EC T BLK": "#888283",
"EC GRY/ EC T NVY": "#888283",
"EC L GRY/ EC GRY": "#DFDED9",
"EC TR PACIF BLUE": "#536A9A",
"ECO AQUA": "#92CED9",
"ECO BLACK": "#2A292C",
"ECO BLK/ ECO GRY": "#000000",
"ECO CANVAS": "#FBF3E6",
"ECO GREY": "#888283",
"ECO GREY STARS": "#909092",
"ECO GREY/ CAMO": "#AEA4A3",
"ECO GRY/ ECO BLK": "#75787B",
"ECO IVORY": "#E1DFDA",
"ECO IVORY/ STARS": "#393749",
"ECO IVRY INK STR": "#F1EEE9",
"ECO LIGHT GREY": "#DAD5D2",
"ECO NAVY": "#4B4F54",
"ECO PACIFIC BLUE": "#536A9A",
"ECO ROSE QUARTZ": "#DFC7C5",
"ECO TR ARMY GRN": "#AEAF8F",
"ECO TR BLACK": "#000000",
"ECO TR ROSE QRTZ": "#C4A4A7",
"ECO TRU NAVY": "#161D2F",
"ECO TRUE BLACK": "#000000",
"ECO TRUE CAMEL": "#DAA86B",
"ECO TRUE CURRANT": "#91494D",
"ECO TRUE NAVY": "#393B51",
"ECO TRUE RED": "#D02538",
"ECO WHITE": "#F3F3F3",
"ECRU/ BLACK": "#D7D2C5",
"EL BLUE/ NEON GR": "#3A9CDB",
"ELC BLU/ CL NVY": "#0090DA",
"ELECTRIC BLUE": "#0090DA",
"ELECTRIC GREEN": "#63A54C",
"ELEPHANT GREY": "#9C9688",
"EMER FLK/ NEO YL": "#63C896",
"EMERAL TRIBLEND": "#003300",
"EMERALD": "#5F8949",
"EMERALD TRIBLEND": "#003300",
"EMERLD/ NEON YLW": "#36D3B4",
"ENVY": "#2EBC85",
"ESPRESSO": "#5D4440",
"ETERNITY": "#1E7FDC",
"Earth Green": "#aed776",
"Eco Black": "#2A292C",
"Eco Cardinal": "#8a1b33",
"Eco Dark Green": "#00523e",
"Eco Dark Grey": "#737470",
"Eco Dark Grey/ White": "#737470",
"Eco Dusty Rose": "#C48490",
"Eco Marine Blue": "#01549A",
"Eco Maroon": "#5d1d2a",
"Eco Mint": "#A0CFA8",
"Eco Navy": "#4B4F54",
"Eco Navy/ White": "#333e59",
"Eco Orange": "#e25d3e",
"Eco Power Blue": "#00a8dd",
"Eco Purple": "#3a385e",
"Eco Sand": "#ab9c91",
"Eco Scarlet Red": "#e11f48",
"Eggshell": "#EDE6DB",
"Electric Blue": "#0090DA",
"Electric Blue - B130": "#0000FF",
"Electric Blue Tonal Blend": "#00a3cb",
"Electric Blue/ Carbon": "#0077B5",
"Electric Blue/ Classic Navy Heather": "#0077B5",
"Electric Jade": "#009186",
"Electric Midnight": "#005670",
"Electric Onyx": "#212721",
"Electric Royal": "#213B88",
"Electric Sky": "#71c5e8",
"Electric Slate": "#888B8D",
"Emerald/ White": "#008E85",
"Energy": "#FF4500",
"English Blue": "#3f5592",
"Erie": "#263147",
"Erosion": "#2d333c",
"Espresso": "#5D4440",
"Eternity": "#1E7FDC",
"Eucalyptus": "#A3B2A4",
"Explorer White/ Plum": "#491c58",
"Explorer/ Brown": "#6b4a35",
"FADED TEAL": "#8FAD9F",
"FATIGUE": "#393E35",
"FERN": "#B2C4A5",
"FIELD KHAKI": "#C7B8A2",
"FIERY RED HTHR": "#FD3057",
"FLAME": "#5C4138",
"FLAMINGO": "#ED7A9E",
"FLO BLUE": "#5576D1",
"FOREST": "#305746",
"FOREST CAMO": "#234F33",
"FOREST CAMO/ BLK": "#3d5143",
"FOREST GREEN": "#22372B",
"FOREST GREN HTHR": "#204711",
"FOREST GRN/ WHT": "#0C550F",
"FOREST HEATHER": "#344820",
"FOREST/ CARBON": "#183028",
"FOREST/ FORST HT": "#395542",
"FOREST/ KHAKI": "#224337",
"FOSSIL GREY": "#3F3F3F",
"FR RED HTH/ OXFR": "#CB333B",
"FRCH BL/ F BL HT": "#2D68C4",
"FRE CRL FLK/ MAG": "#E85875",
"FRE CRL/ MAGENTA": "#E85875",
"FRENCH BLU/ WHT": "#2D68C4",
"FRENCH BLUE": "#6B88D2",
"FRENCH BLUE HTHR": "#4060AF",
"FRENCH BLUE/ WHT": "#2D68C4",
"FRESHWATER": "#6BD4E7",
"FRST GRN SNW HTH": "#153E35",
"FRST GRN/ NATURL": "#273B32",
"FUCHSIA TRIBLEND": "#BE6382",
"Fabric Stripes": "#000000",
"Fairisle Moose/ Brown": "#6b4a35",
"Fan Deep Royal": "#21366E",
"Fashion Camo": "#32572b",
"Fashion Camo/ Black": "#000000",
"Fatigue": "#393E35",
"Fatigue Green": "#54513E",
"Fatigue/ Khaki": "#4e4f3f",
"Festival Tie-Dye": "#f80808",
"Field Khaki": "#C7B8A2",
"Field Khaki/ Black": "#745436",
"Fiji": "#1F6C5A",
"Fiji Blue": "#0066ae",
"Fire Red": "#BA0C2F",
"Fireball Red/ Charcoal": "#b82132",
"Flamingos Pink": "#DD74A1",
"Flashback": "#07131F",
"Flatirons/ Teal": "#1E6B7F",
"Flint Grey": "#b1aca8",
"Flo Rainbow": "#e7a1bc",
"Flo Rainbow Spiral": "#e7a1bc",
"Floral Camo": "#807c6c",
"Floral Mist": "#ffffff",
"Fluorescent Rainbow Spiral": "#1D698D",
"Fluorescent Red": "#FF0000",
"Fluorescent Red (1710)": "#FF0000",
"Fluorescent Red (1715)": "#FF0000",
"Fluorescent Red (1750)": "#FF0000",
"Fluorescent Red (9700)": "#FF0000",
"Fluorescent Red (S5702)": "#FF0000",
"Fluorescent Red (S5704)": "#FF0000",
"Fluorescent Yellow": "#fae574",
"Fluorescent Yellow/ Charcoal": "#b1d233",
"Fluorescent Yellow/ Green/ Grey": "#fae574",
"Fluorescent Yellow/ Green/ Navy": "#fae574",
"Fluorescent Yellow/ Navy": "#b1d233",
"Fog": "#7b8a8e",
"Fog/ White": "#F2F8F7",
"Forest": "#305746",
"Forest Camo": "#234F33",
"Forest Camo Heather": "#706b57",
"Forest Green": "#22372B",
"Forest Green/ Heather": "#22372B",
"Forest Green/ Stone": "#09322f",
"Forest Tonal Blend": "#284232",
"Forest/ Carbon": "#183028",
"Forest/ Gold": "#0d4003",
"Forest/ Graphite": "#0d4003",
"Forest/ Khaki": "#224337",
"Forest/ Natural/ Khaki": "#09322f",
"Forest/ Stone": "#09322f",
"Forest/ White": "#0d4003",
"French Blue": "#6B88D2",
"French Blue Melange": "#3474a6",
"French Blue/ Crystal Blue": "#3474a6",
"French Blue/ White": "#3474a6",
"French Grey": "#c5c8c3",
"French Navy": "#1a2238",
"Frog Skin Camo Aqua": "#32572b",
"Frog Skin Camo Light Pink": "#ffbdc5",
"Frog Skin Camo/ Brown": "#32572b",
"Frog Skin Camo/ Green": "#32572b",
"Frog Skin Green": "#008000",
"Front Range/ Slate Blue Sarah D": "#8FA3A4",
"Frost Grey": "#b1aca8",
"Frost Grey Heather": "#D4D4E0",
"Fuchsia": "#F51B8D",
"Fuchsia Pink": "#F633CF",
"G HT/ G HT/ F BL": "#A2AAAD",
"GARNET": "#71001C",
"GOLD": "#FFD600",
"GOLD NAVY": "#FBD34F",
"GOLDEN YELLOW": "#FFD600",
"GOLDENROD": "#FFD600",
"GRAN HTH/ VN SMK": "#54585A",
"GRAN HTHR STAR": "#676767",
"GRANITE": "#8E9497",
"GRANITE HTH/ BLK": "#54585A",
"GRANITE HTH/ WHT": "#7A7C77",
"GRANITE STRIPE": "#333F48",
"GRAPE": "#544D76",
"GRAPE HEATHER": "#7C7FAB",
"GRAPE TRIBLEND": "#7B65CA",
"GRAPE/ GRAPE HTH": "#7C7FAB",
"GRAPHITE": "#A1A3A1",
"GRAPHITE BLACK": "#413D3F",
"GRAPHITE HEATHER": "#ACABB0",
"GRAPHITE/ BLACK": "#49515C",
"GRAPHITE/ WHITE": "#63666A",
"GRAVEL": "#B3B2B7",
"GRAY": "#747472",
"GRAY CHAMBRAY": "#ACA9A4",
"GRAY MELANGE": "#C7C3C2",
"GREEN": "#1A8573",
"GREEN APPLE": "#358650",
"GREEN CAMO": "#7C824F",
"GREEN MIST": "#B5B58E",
"GREEN TRBLND": "#71AC68",
"GREEN TRIBLEND": "#6B9C83",
"GREEN WOODLAND": "#81815F",
"GREY": "#64656A",
"GREY ACID FLEECE": "#8F8F8F",
"GREY DENIM": "#8E9196",
"GREY HEATHER": "#C2C2C2",
"GREY PIGMENT": "#B8B7B8",
"GREY TRIBLEND": "#ADB1B0",
"GREY/ BLACK": "#838584",
"GREY/ BLACK TRIB": "#888B8D",
"GREY/ NAVY TRB": "#888788",
"GREY/ RED TRBLND": "#808080",
"GREY/ RED TRIBLD": "#888B8D",
"GREY/ ROYAL TRIB": "#888B8D",
"GRN HT/ V SMK/BK": "#54585A",
"GRN HTH/ VN SMK": "#54585A",
"GRNT HTH/ VN SMK": "#54585A",
"GRY/ CHR BLK TRB": "#888788",
"GUAVA": "#F28071",
"GUNMETAL": "#56514E",
"Garnet": "#71001C",
"Ginger": "#feeab2",
"Giza": "#2B2C30",
"Glacier": "#69B3E7",
"Glacier Blue": "#ABCDEF",
"Glacier/ White": "#76B1BA",
"Gobi": "#2d333c",
"Gold": "#FFD600",
"Gold Tonal Blend": "#ffa900",
"Gold/ Black": "#ffa900",
"Gold/ Graphite": "#ffa900",
"Gold/ White": "#ffa900",
"Golden Brown/ Khaki": "#B9975B",
"Golden Pecan": "#C6893F",
"Golden Wheat Heather": "#E4C065",
"Granite Heather": "#54585A",
"Granite/ White": "#5F5E62",
"Grape": "#544D76",
"Grape Leaf": "#4a342b",
"Graphite": "#A1A3A1",
"Graphite Black": "#413D3F",
"Graphite Melange": "#4d464d",
"Graphite Melange/ Graphite": "#4d464d",
"Graphite Tonal Blend": "#474d4e",
"Graphite Tri Blend": "#171718",
"Graphite/ Black": "#49515C",
"Graphite/ Lime": "#474d4e",
"Graphite/ Silver": "#4d464d",
"Graphite/ White": "#63666A",
"Grass Green": "#008000",
"Grass/ White": "#008000",
"Gravel": "#B3B2B7",
"Green": "#1A8573",
"Green - B123": "#4cbb17",
"Green Camo": "#7C824F",
"Green Camo/ Black": "#51695d",
"Green Camo/ Stars & Stripes": "#605951",
"Green Camo/ Tan": "#616545",
"Green Camo/ White": "#32572b",
"Green Duck Camo": "#000000",
"Green Field Camo/ Java": "#284734",
"Green Floral": "#ffffff",
"Green Fluorescent": "#32572b",
"Green Moss": "#367319",
"Green Palm/ Khaki": "#00774f",
"Green Stripe": "#32572b",
"Green Tea": "#9db092",
"Green Teal Heather/ Birch": "#32572b",
"Green Woodland Camo": "#5b624f",
"Green/ Camel/ Brown": "#00523e",
"Green/ Lime - B204": "#4cbb17",
"Green/ White Plaid": "#1B5521",
"Grey": "#64656A",
"Grey - B131": "#000000",
"Grey Aqua Water": "#8ed0cf",
"Grey Bone Fish": "#ffffff",
"Grey Buffalo": "#9D9E98",
"Grey Camo": "#747474",
"Grey Camo Dots": "#848283",
"Grey Camo/ Black": "#64625b",
"Grey Cow/ White": "#b1aca8",
"Grey Denim": "#8E9196",
"Grey Heather": "#C2C2C2",
"Grey Heather/ Black": "#B0B7BC",
"Grey Heather/ White": "#848283",
"Grey Marble": "#b1aca8",
"Grey Melange": "#97999B",
"Grey Mineral Wash": "#DADAD9",
"Grey Mist": "#919193",
"Grey Mist Water": "#8fb1dc",
"Grey Tie Dye": "#7D7D89",
"Grey Triblend": "#ADB1B0",
"Grey Water": "#97999B",
"Grey/ Black": "#838584",
"Grey/ Black Buffalo": "#9D9E98",
"Grey/ Black/ Black/ Grey": "#848283",
"Grey/ Blue Stripe": "#6d94ca",
"Grey/ Brown": "#776E64",
"Grey/ Burgundy/ Black": "#b1aca8",
"Grey/ Caramel/ Black": "#b1aca8",
"Grey/ Charcoal": "#64625b",
"Grey/ Charcoal/ Black": "#4d464d",
"Grey/ Khaki": "#b1aca8",
"Grey/ Navy": "#737470",
"Grey/ Rainbow": "#7b8a8e",
"Grey/ Red": "#AB989D",
"Grey/ Royal": "#AB989D",
"Grey/ Snow Leopard/ White": "#848283",
"Grey/ White": "#b1aca8",
"Grey/ White Speckled": "#64625b",
"Grey/ White/ Black Tri": "#64625b",
"Greyscale": "#969295",
"Greystone": "#888B8D",
"Gulf": "#6f9ba4",
"Gunmetal Heather": "#7E8083",
"Gunmetal Heather/ Army Heather": "#7E8083",
"Gunmetal Heather/ Black": "#7E8083",
"Gunmetal Heather/ Burgundy Heather": "#7E8083",
"Gunmetal Heather/ Charcoal Heather": "#7E8083",
"Gunmetal Heather/ Classic Navy Heather": "#7E8083",
"H PURPLE/ TR PUR": "#5D4D76",
"HEATHER": "#767C7C",
"HEATHER BAY BLUE": "#39B5D9",
"HEATHER BLACK": "#262223",
"HEATHER BLUE": "#46638B",
"HEATHER BRONZE": "#C04C36",
"HEATHER CARDINAL": "#C03545",
"HEATHER CHARCOAL": "#2D2E30",
"HEATHER COOL BLU": "#5B6B8F",
"HEATHER DARK GRY": "#3F4444",
"HEATHER DK GREY": "#3F4444",
"HEATHER DRK GREY": "#3F4444",
"HEATHER DUST": "#DCCFBF",
"HEATHER FOREST": "#2A493C",
"HEATHER GRAY": "#A7A8AA",
"HEATHER GREEN": "#607167",
"HEATHER GREY": "#9EA2A2",
"HEATHER MAROON": "#600E12",
"HEATHER MAUVE": "#A26666",
"HEATHER MUSTARD": "#DB9325",
"HEATHER NAVY": "#626870",
"HEATHER OLIVE": "#766A52",
"HEATHER ORCHID": "#D39CA1",
"HEATHER PACIFIC": "#6E8187",
"HEATHER PEACH": "#FEC6A5",
"HEATHER RASPBRRY": "#A83D72",
"HEATHER SAPPHIRE": "#2D8FCC",
"HEATHER SLATE": "#B6ADA5",
"HEATHER STONE": "#939182",
"HEATHER SUNSET": "#EA9A7F",
"HEATHER TEAL": "#445565",
"HEATHER TEJA": "#A53F3A",
"HEATHER TRUE ROY": "#285FA2",
"HEATHER/ BLACK": "#898A8B",
"HEATHER/ NAVY": "#898A8B",
"HEATHER/ RED": "#B7B7B7",
"HEATHER/ ROYAL": "#898A8B",
"HEATHER/ WHITE": "#898A8B",
"HEATHER/BLACK": "#9D9391",
"HEATHR COOL GREY": "#D7CCC6",
"HEATHR DEEP TEAL": "#66828E",
"HEATHR SAND DUNE": "#ECCBAA",
"HEATHR SLATE BLU": "#5C6D7C",
"HEAVY METAL": "#63626A",
"HELICONIA": "#C8287B",
"HERITAGE ROYAL": "#2E4F7C",
"HI VIS YELLOW": "#DFF200",
"HIBISCUS": "#FD6F7F",
"HIBISCUS/ BROWN": "#ED616E",
"HORIZON ORANGE": "#F98C63",
"HOT CORAL TRBLND": "#D7726A",
"HOT PINK": "#DB5879",
"HOT PINK/ WHITE": "#FFFFFF",
"HT DK GY/ H RSPB": "#515360",
"HT GR/ HT DK GRY": "#9EA4A4",
"HT GY/ HT DK GRN": "#9EA4A4",
"HT/ WH/ HT WH ST": "#888B8D",
"HTH AUBERGINE": "#5D3754",
"HTH BLU/ NEO YEL": "#7487AD",
"HTH BLUE/ HT GRY": "#415089",
"HTH CARIB BLUE": "#0FA8E1",
"HTH DARK GREEN": "#203F41",
"HTH DARK GREY": "#3F4444",
"HTH DK GY/ DK GY": "#3F4444",
"HTH DK GY/ HT RD": "#53535A",
"HTH GALAP BLUE": "#005A70",
"HTH GR/ HTH GBLU": "#9EA2A2",
"HTH GR/ TR HBLUE": "#9EA4A4",
"HTH GRN/ NEO YEL": "#9BB768",
"HTH GRY INV STRP": "#B8BCC5",
"HTH GRY/ HTH BLU": "#9EA2A2",
"HTH GRY/ HTH GRP": "#515360",
"HTH GRY/ HTH GRY": "#A7A8AA",
"HTH GRY/ HTH NVY": "#9EA2A2",
"HTH PRP/ HTH GRY": "#725FA5",
"HTH PRP/ NEO YEL": "#544369",
"HTH SPT DRK NAVY": "#595478",
"HTH SPT SCRLT RD": "#B4243D",
"HTHR BLACK/ BLK": "#43434B",
"HTHR BLUE/ NAVY": "#97B9E9",
"HTHR BROWN/ BRWN": "#644D3D",
"HTHR CARIB BLUE": "#10A9E2",
"HTHR CHARCOAL": "#B1B3B3",
"HTHR CITY GREEN": "#3D441E",
"HTHR COLUM BLUE": "#6ABCCA",
"HTHR DEEP TEAL": "#5F7E83",
"HTHR DUSTY BLUE": "#CDE3E1",
"HTHR FOREST GRN": "#3C4D45",
"HTHR GRAY/ BLACK": "#999999",
"HTHR GREEN/ FOR": "#7CA271",
"HTHR GREY/ BLACK": "#B0B0B2",
"HTHR GRY/ KL GRN": "#ADADAD",
"HTHR IRISH GREEN": "#00966C",
"HTHR MIDNITE NVY": "#434A59",
"HTHR MILITRY GRN": "#69725F",
"HTHR NVY/ MDNITE": "#222953",
"HTHR PURPLE/ WHT": "#A4ADE6",
"HTHR RASPBERRY": "#9C2F69",
"HTHR RDNT ORCHID": "#A3699C",
"HTHR SLATE/ BLK": "#BFB1AE",
"HTHR SPORT BLACK": "#453536",
"HTHR SPORT ROYAL": "#1D4F91",
"HTHR TAN/ BROWN": "#CCBBB1",
"HTHR TR ROY/ NVY": "#3053A7",
"HTHR TRUE ROYAL": "#3E5694",
"HTHR YELLOW GOLD": "#F4BB54",
"HTHR/ VN BURGNDY": "#888B8D",
"HUNTER": "#305739",
"HUNTER GREEN": "#2E4A3B",
"HV-Fluorescent Yellow/ Green": "#fae574",
"HVY MTL/ HVY MTL": "#5B5659",
"Hail": "#b8c9e1",
"Harbor Mist": "#7ba4db",
"Harbor Mist Heather": "#7ba4db",
"Hardwood Green/ Olive": "#E1D9C5",
"Harvest Duck Camo/ Light Brown": "#6b4a35",
"Harvest Gold": "#FAD085",
"Hawaiin Biome": "#ffffff",
"Hawaiin Rainforest": "#ffffff",
"Hawaiin Sky": "#ffffff",
"Haze Tie Dye": "#C7C9C7",
"Hazel": "#B59F88",
"Heather": "#767C7C",
"Heather Black": "#262223",
"Heather Black/ Heather Grey": "#1b151a",
"Heather Black/ Truffle": "#484648",
"Heather Blue Lagoon": "#A3B4B5",
"Heather Brown": "#847363",
"Heather Cardinal": "#C03545",
"Heather Charcoal": "#2D2E30",
"Heather Charcoal/ Black": "#54565b",
"Heather Charcoal/ White": "#64625b",
"Heather Columbia Blue": "#6c8cb7",
"Heather Cranberry": "#8e1a24",
"Heather Dark Green/ Silver": "#09322f",
"Heather Dark Grey": "#64625b",
"Heather Dark Royal": "#305791",
"Heather Denim": "#8faacb",
"Heather Denim/ Navy": "#8faacb",
"Heather Dust": "#DCCFBF",
"Heather Forest": "#2A493C",
"Heather Fuchsia": "#EF4A81",
"Heather Granite": "#75787B",
"Heather Graphite": "#707372",
"Heather Grey": "#9EA2A2",
"Heather Grey/ Amber Gold": "#7b8a8e",
"Heather Grey/ Birch/ Amber Gold": "#737470",
"Heather Grey/ Birch/ Army": "#7b8a8e",
"Heather Grey/ Birch/ Army Olive": "#737470",
"Heather Grey/ Birch/ Biscuit": "#64625b",
"Heather Grey/ Birch/ Cardinal": "#7b8a8e",
"Heather Grey/ Birch/ Loden": "#b1aca8",
"Heather Grey/ Black": "#4c504b",
"Heather Grey/ Canada Flag": "#64625b",
"Heather Grey/ Charcoal/ Black": "#7b8a8e",
"Heather Grey/ Charcoal/ Charcoal": "#7b8a8e",
"Heather Grey/ Charcoal/ Dark Orange": "#b1aca8",
"Heather Grey/ Charcoal/ Forest Green": "#7b8a8e",
"Heather Grey/ Charcoal/ Navy": "#737470",
"Heather Grey/ Charcoal/ Orange": "#737470",
"Heather Grey/ Charcoal/ Red": "#737470",
"Heather Grey/ Charcoal/ Royal": "#737470",
"Heather Grey/ Charcoal/ Vegas Gold": "#737470",
"Heather Grey/ Colorado Flag": "#64625b",
"Heather Grey/ Dark Charcoal": "#64625b",
"Heather Grey/ Heather Charcoal": "#75797b",
"Heather Grey/ Navy": "#7b8a8e",
"Heather Grey/ Red/ Mexico Flag": "#64625b",
"Heather Grey/ Royal": "#7b8a8e",
"Heather Grey/ Rust": "#64625b",
"Heather Grey/ Stars & Stripes": "#b1aca8",
"Heather Grey/ Texas Flag": "#4d464d",
"Heather Grey/ USA Flag": "#64625b",
"Heather Grey/ White": "#4c504b",
"Heather Kelly": "#26EDBB",
"Heather Kelly Green": "#00845e",
"Heather Lake Blue": "#007db6",
"Heather Lake Blue/ Navy": "#007db6",
"Heather Lieutenant": "#505a46",
"Heather Light Blue": "#b5ccde",
"Heather Light Grey": "#A2A7A1",
"Heather Light Navy": "#333e59",
"Heather Maroon": "#600E12",
"Heather Mauve": "#A26666",
"Heather Medium Blue": "#A4C8E1",
"Heather Moss": "#3D441E",
"Heather Mustard": "#DB9325",
"Heather Navy": "#626870",
"Heather Navy/ Light Grey": "#333e59",
"Heather Orange": "#FE8A71",
"Heather Pink Gravel": "#f4bed0",
"Heather Plum": "#4F1732",
"Heather Purple": "#6B5E96",
"Heather Purple (disc)": "#614B79",
"Heather Red": "#C33952",
"Heather Red/ Light Grey": "#f80808",
"Heather Royal": "#5698EE",
"Heather Royal (disc)": "#154f97",
"Heather Royal/ Light Grey": "#305791",
"Heather Slate": "#B6ADA5",
"Heather Steel": "#97999B",
"Heather Tan/ Black": "#B5A186",
"Heather Tri Blend": "#54565b",
"Heather True Royal": "#0033A0",
"Heather White": "#FFFFFF",
"Heather/ Black": "#898A8B",
"Heather/ Navy": "#898A8B",
"Heather/ White": "#898A8B",
"Heathered Blue": "#3B60AF",
"Heathered Grey": "#B1B3B3",
"Heathered Navy": "#004976",
"Heathered Red": "#A4343A",
"Heathered Steel": "#B1B4B3",
"Heavy Metal": "#63626A",
"Heliconia": "#C8287B",
"Heritage Black Plaid": "#2C282C",
"Hi Vis Yellow": "#DFF200",
"Hickory Heather": "#5D504A",
"High Viz Yellow": "#fced00",
"Honey": "#ceb47e",
"Honey Dew": "#BAE1D3",
"Hot Pink": "#DB5879",
"Hot Pink Realtree AP": "#F633CF",
"Hot Pink Tonal Blend": "#a5246b",
"Hot Pink/ Black": "#F633CF",
"Hot Pink/ Rainbow": "#F633CF",
"Hounddog": "#876155",
"Hunter Green": "#2E4A3B",
"Hydrangea": "#A7BCD6",
"IC GRY FL/ NE GN": "#D6D6D8",
"ICE BL/ D HTR GR": "#B3B4B6",
"ICE BLU TRIBLND": "#CFEEF1",
"ICE BLUE TRBLND": "#CFEEF1",
"ICE BLUE TRIBLND": "#CFEEF1",
"ICE FLECK": "#D9D9DA",
"ID MAROON": "#560321",
"ID ORION": "#293E4F",
"ID SILVER": "#352F2F",
"INDEPENDENCE RED": "#892034",
"INDEPENDENT": "#932D39",
"INDIGO": "#3A4861",
"INDIGO DENIM": "#28334A",
"INDIGO HTH/ OXFR": "#263145",
"INDIGO/ BLK/ KH": "#26547C",
"INDIGO/ SILK": "#8FABB7",
"INDIGO/ WHITE": "#222953",
"INDUSTRY BLUE": "#93AAD6",
"IRISH GREEN": "#026D07",
"IRISH GREEN HTHR": "#00B373",
"IRON/ WHITE": "#C9C9C9",
"ISLAND BLUE": "#D7E5ED",
"ISLAND REEF": "#7FEAE2",
"IVORY": "#FFFFF0",
"Ice Blackout": "#ada8a5",
"Ice Blue": "#E0F1F5",
"Ice Blue Heather/ Navy": "#3474a6",
"Ice Camo": "#d0d3d7",
"Ice Purple": "#464E7E",
"Iced Beige": "#CABFAD",
"Iced Brown": "#654831",
"Iced Green": "#8FBC8F",
"Iced Grey": "#97999B",
"Iced Navy": "#012943",
"Iced Silver": "#C8C9C7",
"Icelandic Blue": "#01549A",
"Illusion": "#ffffff",
"Indigo": "#3A4861",
"Indigo Denim": "#28334A",
"Indigo Heather": "#131F2F",
"Inked India": "#463f69",
"Irish Green": "#026D07",
"Iron Gate": "#919193",
"Iron Grey": "#64625b",
"Iron Grey/ White": "#64625b",
"Island Paradise": "#474d4e",
"Island Tie Dye": "#9CDBD9",
"Ivory": "#FFFFF0",
"Ivory Corduroy": "#ddd5c1",
"Ivory/ Jade/ White/ Swirl": "#ddd5c1",
"Ivory/ Lavender/ White/ Smiley": "#ddd5c1",
"Ivory/ Sherbert/ White/ Floral": "#ddd5c1",
"J NAVY": "#253355",
"J NAVY/ CHRCL GR": "#253355",
"J. Navy": "#253355",
"J.NAVY": "#0A2245",
"JADE": "#00A09C",
"JADE HEATHER": "#00857D",
"JAVA": "#635245",
"JAZZBRY PNK TRBL": "#E7467C",
"JUNGLE": "#7B7C58",
"JZZBRRY PNK TRBL": "#E7467C",
"Jade": "#00A09C",
"Jade Tri Blend": "#00836b",
"Jade/ Daisy": "#008E85",
"Jade/ Daisy/ Khaki": "#008E85",
"Jellybean": "#c5b4e3",
"Jewel/ Navy/ White": "#93BDB4",
"KANATI CAMO": "#413328",
"KELLY": "#009A63",
"KELLY GREEN": "#009A63",
"KELLY GREEN HTHR": "#008755",
"KELLY GREEN/ WHT": "#2DCCA3",
"KELLY GRN TRBLND": "#009564",
"KELLY POLKA DOT": "#0A8955",
"KELLY/ RED": "#008264",
"KELLY/ WHT/ KLY": "#07A644",
"KEY LIME": "#B7DD79",
"KHAKI": "#C1B09E",
"KHAKI GREEN": "#A09151",
"KHAKI HEATHER": "#AA9C8F",
"KHAKI/ BLACK": "#C6B197",
"KHAKI/ BLK/ BLK": "#B0A295",
"KHAKI/ CHARCOAL": "#C4AD91",
"KHAKI/ FOREST": "#B5A177",
"KHAKI/ MAROON": "#D5CDC2",
"KHAKI/ NAVY": "#B5A177",
"KHAKI/ ROYAL": "#B5A177",
"KHAKI/ TAN": "#968E6A",
"KHK/ SPRUCE GRN": "#B5A177",
"KIWI": "#B7EB00",
"KLLY WH STR/ WHT": "#008264",
"KRYPTEK HGHLANDR": "#603731",
"KRYPTEK PONTUS": "#263264",
"KRYPTEK RAID": "#303038",
"KRYPTEK TYPHON": "#393941",
"KRYPTEK WRAITH": "#D1D1D3",
"KYANOS BLUE": "#2D4187",
"Kale": "#505a46",
"Karma": "#C4D600",
"Kelly": "#009A63",
"Kelly Green": "#009A63",
"Kelly Green/ Khaki": "#00774f",
"Kelly Green/ White/ Clover": "#00774f",
"Kelly Heather": "#007B4B",
"Kelly/ Stone": "#00774f",
"Kelly/ White": "#FFFFFF",
"Kenai": "#A59D87",
"Key Lime": "#B7DD79",
"Khaki": "#C1B09E",
"Khaki Corduroy": "#CCBCAD",
"Khaki Heather/ Khaki": "#B59F88",
"Khaki/ Black": "#C6B197",
"Khaki/ Black Rope": "#B59F88",
"Khaki/ Brown": "#CCBCAF",
"Khaki/ Brown Stitch": "#CCBCAF",
"Khaki/ Camo": "#CCBCAD",
"Khaki/ Coffee": "#CCBCAD",
"Khaki/ Forest Green": "#B59F88",
"Khaki/ Grey": "#E1D9C5",
"Khaki/ Khaki": "#6b4a35",
"Khaki/ Loden": "#B59F88",
"Khaki/ Navy": "#B5A177",
"Khaki/ Navy/ Stone": "#B59F88",
"Khaki/ Olive Stars": "#000000",
"Khaki/ Olive USA": "#000000",
"Khaki/ Sage/ Camo Mesh": "#B59F88",
"Khaki/ Stone": "#CCBCAD",
"Khaki/ White": "#CCBCAD",
"Kiwi": "#B7EB00",
"Kona Blue": "#3474a6",
"Kona Green": "#32572b",
"Kona Lavender": "#aab3d7",
"Kona Pink": "#ffbdc5",
"Kona Yellow": "#fced00",
"Kryptek Highlander - Buck": "#64625b",
"Kryptek Highlander/ Brown": "#64625b",
"Kryptek Highlander/ Buck": "#32572b",
"Kryptek Inferno/ Black": "#32572b",
"Kryptek Inferno/ Blaze Orange": "#32572b",
"Kryptek Neptune/ Black": "#32572b",
"Kryptek Neptune/ White": "#32572b",
"Kryptek Pontus/ White": "#32572b",
"Kryptek Typhon/ Black": "#64625b",
"Kryptek Typhon/ Neon Orange": "#32572b",
"Kryptek Typhon/ Neon Pink": "#64625b",
"Kryptek Typhon/ Neon Yellow": "#32572b",
"L.A. Blue": "#00a8dd",
"LA Blue/ Khaki": "#0033A0",
"LAGOON": "#B8E3EC",
"LAGOON BLUE": "#4AC3E0",
"LAKER PURPLE": "#420F48",
"LAVENDER": "#CAB6D8",
"LAVENDER/ PINK": "#BE9BD3",
"LAVENDER/ PURPLE": "#A699C1",
"LEAD GRAY": "#8B8D8D",
"LEAF": "#A7C69C",
"LEGION BLUE": "#244E5C",
"LEMON": "#FFFF9F",
"LEMON ZEST": "#FFDD56",
"LIGHT BLUE": "#A3B8E4",
"LIGHT DENIM": "#86B0D0",
"LIGHT DENIM/ TAN": "#67A3DB",
"LIGHT FOREST": "#024930",
"LIGHT GRAY": "#D1D1D1",
"LIGHT GREEN": "#768B83",
"LIGHT HEATHER": "#AFAFB1",
"LIGHT LODEN": "#A79871",
"LIGHT NAVY": "#3C4252",
"LIGHT PINK": "#FFE4E4",
"LIGHT ROSE PINK": "#E6D1D1",
"LIGHT STEEL": "#BFBABA",
"LIGHT TEAL": "#AECBC9",
"LILAC MIST": "#BDB1BB",
"LILAC/ D HTR GRY": "#B3B4B6",
"LILAC/ HTHR GRAY": "#EED5F2",
"LIME": "#C2FF6E",
"LIME GREEN": "#A7C254",
"LIME/ MAUI BLUE": "#97CF6B",
"LIQUID CARDINAL": "#7E2833",
"LIQUID COAL": "#66625F",
"LIQUID NAVY": "#394158",
"LIQUID SILVER": "#CAC9CF",
"LODEN GREEN": "#696B40",
"LOTUS": "#2D4368",
"LT BLUE/ INDIGO": "#9BB8D3",
"LT BLUE/ WHITE": "#B8CCEA",
"LT DENIM/ OF WHT": "#93B7D1",
"LT GREY HEATHER": "#C5BDBA",
"LT GREY MARBLE": "#BAB7B5",
"LT GRY/ NEON GRN": "#D4D6D5",
"LT HEATHER GREY": "#C6C6C6",
"LT HTHR/ CARBON": "#7C878E",
"LT NAUTICAL BLU": "#0868B2",
"LT STEEL/ NAVY": "#CED1D8",
"LT STL/ CHAR HTH": "#CED1D8",
"LT STL/ N BL HTH": "#CED1D8",
"LT STL/ N PK HTH": "#CED1D8",
"Lagoon": "#B8E3EC",
"Lagoon Tie Dye": "#91a6db",
"Lake": "#333e59",
"Lake Blue": "#E0E6D7",
"Lake Blue Corduroy": "#3474a6",
"Lapis": "#23377C",
"Lapis Blue": "#004B8D",
"Lapis Green": "#2B979D",
"Latte": "#7A6855",
"Laurel Green": "#799a79",
"Lavender": "#CAB6D8",
"Lavender/ Khaki": "#3a385e",
"Lavender/ Stripes": "#aab3d7",
"Lead": "#8B8C85",
"Lead Grey": "#8B8C89",
"Leaf Green": "#32572b",
"Legion Blue": "#244E5C",
"Lemon": "#FFFF9F",
"Lemon Lime": "#000000",
"Leopard": "#DCAA75",
"Leopard/ Black": "#6b4a35",
"Light Avio Blue": "#3474a6",
"Light Beige": "#807c6c",
"Light Blue": "#A3B8E4",
"Light Blue Melange": "#add8e6",
"Light Blue/ Cardinal": "#b5ccde",
"Light Blue/ Heather Grey": "#b0cfea",
"Light Blue/ Khaki": "#b5ccde",
"Light Blue/ Navy": "#BBD6F3",
"Light Blue/ Navy/ Navy/ Graffiti": "#b5ccde",
"Light Blue/ Navy/ White": "#b5ccde",
"Light Blue/ Sand": "#b5ccde",
"Light Blue/ White": "#b5ccde",
"Light Blue/ White Polka Dots": "#b5ccde",
"Light Brown": "#B59F88",
"Light Charcoal": "#8a9b9e",
"Light College Blue": "#5f8dda",
"Light Denim": "#86B0D0",
"Light Green/ White": "#32572b",
"Light Grey": "#999999",
"Light Grey Heather": "#787a81",
"Light Grey Melange": "#A2A7A1",
"Light Grey/ Black": "#968E8B",
"Light Grey/ Charcoal": "#9c958f",
"Light Grey/ Polka Dots": "#b1aca8",
"Light Grey/ Salmon/ Dark Grey": "#b1aca8",
"Light Grey/ Seafoam/ Silver": "#b1aca8",
"Light Grey/ Snow Leopard": "#b1aca8",
"Light Grey/ White": "#D3D3D3",
"Light Heather Grey": "#dcdddb",
"Light Mint": "#6DCDB8",
"Light Mint/ Dark Mint/ Black": "#6DCDB8",
"Light Nautical Blue": "#307FE2",
"Light Nautical Blue Heather": "#307FE2",
"Light Navy": "#3C4252",
"Light Olive": "#898D6D",
"Light Olive Green": "#94926c",
"Light Olive Green/ Stone": "#94926c",
"Light Olive/ Khaki": "#65665C",
"Light Olive/ Stone": "#65665C",
"Light Pink": "#FFE4E4",
"Light Pink/ Floral": "#fcdfe2",
"Light Pink/ White": "#daa7b8",
"Light Sage": "#8BAA99",
"Light Spice": "#CCBCAD",
"Light Steel": "#BFBABA",
"Light Tan": "#ad9e8b",
"Light Washed Denim": "#909FAC",
"Light Yellow": "#F5E1A4",
"Lilac": "#E0BBE7",
"Lilac Tri Blend": "#4f4e85",
"Lilac/ Birch": "#D358F7",
"Lime": "#C2FF6E",
"Lime Green": "#A7C254",
"Lime/ Black": "#DFFD0F",
"Lime/ Blue": "#DFFD0F",
"Lime/ Green": "#DFFD0F",
"Lime/ Red": "#DFFD0F",
"Lime/ White (PL-V18)": "#DFFD0F",
"Linen": "#E1D9C5",
"Loden": "#828A64",
"Loden Green": "#696B40",
"Loden Green/ Black": "#777056",
"Loden/ Amber Gold": "#777056",
"Loden/ Black": "#777056",
"Loden/ Green Camo": "#777056",
"Loden/ Khaki": "#777056",
"Lodgepole/ Black": "#1b151a",
"London Grey": "#999999",
"Lotus": "#2D4368",
"MACCHIATO": "#464545",
"MAG FLCK/ NEO YL": "#B952B3",
"MAGENTA HEATHER": "#D58CC1",
"MAGENTA/ NEON YL": "#C77AC8",
"MAIZE": "#FBDE9A",
"MARBLED CHARCOAL": "#63666A",
"MARBLED NAVY": "#1F2A44",
"MARBLED ORANGE": "#FE7245",
"MARBLED PURPLE": "#4E1E7A",
"MARBLED ROYAL": "#1D4F91",
"MARBLED SAPPHIRE": "#0091C7",
"MARINE BLU/ TAN": "#236192",
"MAROON": "#88353C",
"MAROON HEATHER": "#8C405A",
"MAROON MARBLE": "#AA3D47",
"MAROON MIST": "#54121C",
"MAROON TRIBLEND": "#752D38",
"MAROON/ GRAY": "#88353C",
"MAROON/ NATURAL": "#5D2735",
"MAROON/ WHITE": "#88353C",
"MAUI BLUE": "#559BF3",
"MAUVE": "#A26666",
"MAUVE TRIBLEND": "#A86E6D",
"MAUVELOUS MLANGE": "#F9BDBC",
"MAUVELOUS/ BLRNA": "#FDA7B2",
"MAUVELOUS/ NAT": "#FDA7B2",
"MD NY/ D HTR GRY": "#B3B4B6",
"MDNT NVY/ NATURL": "#1A2642",
"MEADOW": "#3C6A46",
"MELANGE DARK GRY": "#6F6566",
"MELANGE GREY": "#C2B4B1",
"MELANGE SILVER": "#B5AFAF",
"METALLIC GOLD": "#C3A06A",
"METALLIC PINK": "#9E1D7A",
"METALLIC ROYAL": "#393ECE",
"METALLIC SILVER": "#B5B5B5",
"MID NVY/ HTH GRY": "#202339",
"MID NY/ HTHR GRY": "#092263",
"MIDNIGHT": "#3D3B49",
"MIDNIGHT BLUE": "#5E6C75",
"MIDNIGHT NAVY": "#1A2642",
"MILITARY GREEN": "#63655A",
"MILITARY GRN TRB": "#4A4837",
"MILTRY GRN MLNGE": "#B9B09F",
"MILTRY GRN/ BLK": "#66664C",
"MILTRY GRN/ CRM": "#A8A187",
"MINERAL BLACK": "#616671",
"MINERAL GRAY": "#8C909B",
"MINERAL NAVY": "#254599",
"MINT": "#BEE0C7",
"MINT HTH/ OXFORD": "#01BE94",
"MINT TRIBLEND": "#D9EDEB",
"MINT/ GRASS": "#A0DAB3",
"MISS MUD/ TAN": "#7E6757",
"MLNG BLU/ ML CHR": "#605F6A",
"MLTRY GRN SNW HT": "#595B3C",
"MLTRY GRN TRBLND": "#646351",
"MOLTEN RED": "#8E2337",
"MOONDANCE": "#F01B1B",
"MOSAIC BLUE HTHR": "#7F9AAB",
"MOSS": "#BCB7B1",
"MULTICAM": "#443224",
"MULTICAM ALPINE": "#F3EDED",
"MULTICAM ARID": "#9F895A",
"MULTICAM BLACK": "#2A292F",
"MULTICAM TROPIC": "#57581F",
"MUSTARD": "#E2BA65",
"MUSTARD/ BAY/ WH": "#C88F42",
"Macaroon": "#d6d2c4",
"Mandarin Orange": "#CF4520",
"Mango": "#f5bd53",
"Manhattan": "#4682B4",
"Manta": "#686a6c",
"Marina Red": "#BA0C2F",
"Marine": "#FFFFFF",
"Marine Blue": "#3474a6",
"Marine Blue/ Coral": "#3474a6",
"Marine Blue/ Grey": "#3474a6",
"Marine Blue/ Khaki": "#333e59",
"Marine Blue/ Navy/ White": "#333e59",
"Marine/ Camel/ Brown": "#01549A",
"Marine/ Khaki": "#425563",
"Marine/ Navy/ Grey": "#3474a6",
"Marine/ Salmon/ Khaki": "#333e59",
"Marlin": "#4169e1",
"Marolina Blue": "#7ba4db",
"Maroon": "#88353C",
"Maroon Heather": "#8C405A",
"Maroon Melange": "#6F2C3F",
"Maroon Tonal Blend": "#3a2128",
"Maroon/ Black": "#5d1d2a",
"Maroon/ Black/ White": "#5d1d2a",
"Maroon/ Charcoal/ Black Tri": "#5d1d2a",
"Maroon/ Classic Navy": "#642133",
"Maroon/ Gold": "#5d1d2a",
"Maroon/ Graphite": "#460000",
"Maroon/ Heather": "#672E45",
"Maroon/ Natural/ Light Pink": "#fcdfe2",
"Maroon/ Silver": "#672E45",
"Maroon/ Stone": "#5d1d2a",
"Maroon/ White": "#88353C",
"Maroon/ White/ Grey": "#5d1d2a",
"Marsh Duck Camo/ Loden": "#32572b",
"Marsh Duck Camo/ Olive Green": "#807c6c",
"Mauve": "#A26666",
"Mauvelous": "#B06F76",
"Mauvelous Spot": "#b06f76",
"Mauvelous/ Mauvelous Spot": "#b06f76",
"Max7": "#6b5742",
"Mazarine Blue": "#273C76",
"Meadow Green": "#32572b",
"Mediterranean": "#000000",
"Medium Blue": "#566991",
"Medium Grey": "#C5D3DE",
"Meerkat": "#7A6855",
"Melange Black/ White": "#000000",
"Melange Grey/ Black": "#b1aca8",
"Melange Grey/ Pacific Blue/ Stone": "#737470",
"Melange Grey/ White": "#b1aca8",
"Melange Light Blue/ Cardinal/ Stone": "#b5ccde",
"Melange Navy/ Bronze/ Stone": "#333e59",
"Melange Navy/ White": "#333e59",
"Melange Scarlet/ White": "#A6192E",
"Mellow Yellow": "#FFA300",
"Melon": "#F8A285",
"Melon Heather": "#FF6347",
"Melon Orange": "#EFB661",
"Melon Orange/ White": "#DF9166",
"Merica/ Khaki": "#333e59",
"Merlot/ White": "#8a1b33",
"Metallic Gold/ White": "#eb9d18",
"Metallic Silver/ White": "#979298",
"Michelangelo": "#1D698D",
"Michelangelo Spiral": "#2d333c",
"Midnight": "#3D3B49",
"Midnight Blue/ White": "#2C435C",
"Midnight Camo": "#333e59",
"Midnight Heathered": "#2c313d",
"Midnight Navy": "#1A2642",
"Midnight Royal": "#8103a1",
"Midnight Tri Blend": "#3f4d69",
"Military Digital Camo/ Light Green": "#51695d",
"Military Green": "#63655A",
"Military Green Heather": "#3A4C00",
"Military Tri Blend": "#5e6665",
"Mindfulness": "#00BFFF",
"Mineral Black": "#616671",
"Mineral Grey": "#716E6A",
"Mineral Navy": "#254599",
"Mink/ Vanilla": "#B5A186",
"Mint": "#BEE0C7",
"Mint Green": "#B3D5BC",
"Mint/ Marine/ Navy": "#A0CFA8",
"Mint/ Navy/ Silver": "#1E6B7F",
"Mirage": "#2d333c",
"Mist": "#7594b3",
"Misty Blue": "#8AACC9",
"Misty Peaks/ Black": "#1b151a",
"Mocha Tri Blend": "#6a4b3e",
"Mojave": "#D1C9BD",
"Moonbeam": "#1D698D",
"Moss": "#BCB7B1",
"Moss Green": "#7A7256",
"Moss Green/ Cinder": "#7A7256",
"Moss Green/ Khaki": "#7A7256",
"Mossy Oak Bottomland/ Black": "#808080",
"Mossy Oak Bottomland/ Loden": "#000000",
"Mossy Oak Break-Up Blaze Orange": "#f36b25",
"Mossy Oak Break-Up Country/ Stars & Stripes": "#f36b25",
"Mossy Oak BreakUp": "#413838",
"Mossy Oak Breakup": "#413838",
"Mossy Oak Breakup/ Black": "#413838",
"Mossy Oak Breakup/ Black Mesh": "#584834",
"Mossy Oak Country": "#6b5742",
"Mossy Oak Country DNA/ Black": "#3a3c3a",
"Mossy Oak Country/ Tan": "#64625b",
"Mossy Oak Elements Blacktip/ Charcoal": "#32572b",
"Mossy Oak Elements Bonefish/ Light Grey": "#32572b",
"Mossy Oak Habitat/ Brown": "#32572b",
"Mossy Oak New Breakup - MO15": "#474238",
"Mossy Oak Obsession/ Khaki": "#808080",
"Mossy Oak Shadow Grass": "#84694c",
"Mossy Oak Shadow Grass Blades": "#84694c",
"Mountain Contours Maroon/ Slate": "#373f41",
"Mountain Morning Aqua/ Peach": "#E29F81",
"Mountain Sunset/ Purple": "#351F65",
"Mt Sunset/ Maroon/ Khaki": "#5d1d2a",
"Mulberry": "#5B2B42",
"Mulitcam Black": "#000000",
"Multi Black": "#25282A",
"Multi Blue": "#00a8cc",
"Multicam Arid/ Tan": "#c8af93",
"Multicam Black": "#2A292F",
"Multicam Original/ Coyote Brown": "#32572b",
"Multicam Tropic/ Loden Green": "#777056",
"Mushroom": "#696156",
"Mustard": "#E2BA65",
"Mustard Corduroy/ Dark Grey": "#c68a32",
"Mustard Yellow": "#c68a32",
"Mustard Yellow/ Navy/ White": "#c68a32",
"Mustard Yellow/ Stone": "#c68a32",
"Mykonos": "#FF6900",
"Mystic": "#3B3A4A",
"M�lange Black": "#000000",
"M�lange Navy": "#333e59",
"M�lange Silver": "#d9d5d4",
"NAT HT/ VN M GRN": "#D7D2CB",
"NAT HTH/ GRAN HT": "#D7D2CB",
"NATURAL": "#F7EFDA",
"NATURAL HTH/ HTH": "#FDF6F0",
"NATURAL/ BLACK": "#F7EFDA",
"NATURAL/ BROWN": "#E9E4D1",
"NATURAL/ FOR GRN": "#E7E3D8",
"NATURAL/ FOREST": "#06974E",
"NATURAL/ HOT PNK": "#C76395",
"NATURAL/ LT BLUE": "#BDE4FE",
"NATURAL/ NAVY": "#F3E9DE",
"NATURAL/ RED": "#E8E0CF",
"NATURAL/ ROYAL": "#F3E9DE",
"NATURL/ FRST GRN": "#F7EFDA",
"NATURL/ MDNT NVY": "#F7EFDA",
"NATURL/ TITANIUM": "#F5ECDA",
"NAUT RED/ TAN": "#8F3946",
"NAUTICAL RED": "#CC2D30",
"NAVY": "#222953",
"NAVY BLUE": "#222953",
"NAVY FLECK": "#414963",
"NAVY FLECK/ NAVY": "#002D47",
"NAVY HEATHER": "#062B60",
"NAVY MELANGE": "#5A5865",
"NAVY MIST": "#28334A",
"NAVY PEPPER": "#575F76",
"NAVY SLUB": "#2E323B",
"NAVY SNOW HEATHR": "#002B49",
"NAVY SPECKLED": "#3F406C",
"NAVY TRIBLEND": "#2E364B",
"NAVY/ BLACK": "#1F2A44",
"NAVY/ CHARCOAL": "#1C2041",
"NAVY/ CHRCL FLK": "#002D47",
"NAVY/ CREME": "#222953",
"NAVY/ DK CHRCOAL": "#222953",
"NAVY/ GOLD": "#29283A",
"NAVY/ GRAPH": "#1F2A44",
"NAVY/ GRAPHITE": "#1F2A44",
"NAVY/ GRAY": "#222953",
"NAVY/ GRAY/ GRAY": "#222953",
"NAVY/ GREY": "#29293D",
"NAVY/ GRP/ N BL": "#1F2A44",
"NAVY/ HTHR GRAY": "#201D2E",
"NAVY/ HTHR GRY": "#1C2041",
"NAVY/ KHAKI": "#26303C",
"NAVY/ NAVY": "#222953",
"NAVY/ NAVY HTHR": "#1F2A44",
"NAVY/ NEON YLW": "#222953",
"NAVY/ RED": "#152D5C",
"NAVY/ RED/ WHITE": "#152D5C",
"NAVY/ SLTE/ WHT": "#0B2E4F",
"NAVY/ STONE": "#1F2A44",
"NAVY/ TAN": "#414753",
"NAVY/ WHITE": "#222953",
"NECTARINE": "#DD7500",
"NEON BL HEATHER": "#1797D9",
"NEON BLUE HTHR": "#006E9B",
"NEON GREEN": "#A7E163",
"NEON HTHR GREEN": "#D7F595",
"NEON HTHR ORANG": "#F9936B",
"NEON HTHR PINK": "#FEA2C5",
"NEON LEMON HTHR": "#B6FA72",
"NEON LIME HTHR": "#CDDBA4",
"NEON ORANGE": "#E5801C",
"NEON ORANGE HTHR": "#F9AB84",
"NEON ORNG/NE YLW": "#F47210",
"NEON PINK": "#E16F8F",
"NEON PINK TRIBLD": "#FF3EB5",
"NEON PNK HEATHER": "#EA87AA",
"NEON RAINBOW": "#1F5FCD",
"NEON RED ORANGE": "#F6A0A6",
"NEON YELLOW": "#C6E970",
"NEON YLW/ NE ORG": "#B3DB22",
"NEW RAILROAD": "#454449",
"NEW RAILROAD GRY": "#6D686C",
"NIAGARA": "#74839A",
"NIAGARA/ BROWN": "#7D8592",
"NIGHT": "#002D56",
"NT HT/ GR HT/ TT": "#EBE2DB",
"NT HT/ V BRG/ NT": "#D7D2CB",
"NT HTH/ V CM/ NT": "#EBE2DB",
"NTRL/ GRN WD/ OR": "#F2EBD1",
"NV/ WH/ NV WH ST": "#051C2C",
"NVY/ GR HT/ GRAP": "#1F2A44",
"NVY/ TTNIUM/ WHT": "#051C2C",
"Nantucket Navy": "#01426A",
"Nantucket Red": "#e11f48",
"Nantucket Red/ Grey": "#f80808",
"Nantucket Red/ Khaki": "#e11f48",
"Nantucket Red/ Stone": "#e11f48",
"Natural": "#F7EFDA",
"Natural Heather": "#D7D2CB",
"Natural/ Army": "#ddd5c1",
"Natural/ Black": "#F7EFDA",
"Natural/ Carolina Blue": "#ddd5c1",
"Natural/ Chocolate": "#ddd5c1",
"Natural/ Forest": "#06974E",
"Natural/ Forest Green": "#ddd5c1",
"Natural/ Gold": "#ddd5c1",
"Natural/ Hot Pink": "#ddd5c1",
"Natural/ Kelly": "#D0CAB2",
"Natural/ Lavender": "#ddd5c1",
"Natural/ Light Pink": "#ddd5c1",
"Natural/ Lime": "#ddd5c1",
"Natural/ Maroon": "#F7EFDA",
"Natural/ Natural": "#ddd5c1",
"Natural/ Navy": "#F3E9DE",
"Natural/ Olive": "#ddd5c1",
"Natural/ Orange": "#D0CAB2",
"Natural/ Purple": "#ddd5c1",
"Natural/ Red": "#E8E0CF",
"Natural/ Royal": "#F3E9DE",
"Natural/ Sapphire": "#ddd5c1",
"Natural/ Sunkissed Stripe": "#b06f76",
"Natural/ Texas Orange": "#ddd5c1",
"Natural/ Turquoise": "#ddd5c1",
"Natural/ White": "#ddd5c1",
"Natural/ Yellow": "#ddd5c1",
"Nautical": "#63a6d6",
"Nautical Red/ Khaki": "#ee344b",
"Navaho": "#e25d3e",
"Naval Academy": "#263147",
"Naval Academy Heather": "#263147",
"Navy": "#222953",
"Navy Admiral": "#333e59",
"Navy Blazer": "#08154a",
"Navy Blue": "#222953",
"Navy Blue - B127": "#282746",
"Navy Camo Dots": "#333e59",
"Navy Camo/ White": "#333e59",
"Navy Chrome": "#253049",
"Navy Field Camo/ Java": "#333e59",
"Navy Flag": "#333e59",
"Navy Heather": "#062B60",
"Navy Heather/ Navy": "#333e59",
"Navy Heather/ White": "#2A304E",
"Navy Heathered": "#2b2e43",
"Navy Melange": "#5A5865",
"Navy Melange/ Navy": "#333e59",
"Navy Mist": "#28334A",
"Navy Slub/ Black": "#333e59",
"Navy Tonal": "#333e59",
"Navy Tonal Blend": "#162631",
"Navy/ Birch/ Red": "#333e59",
"Navy/ Black": "#1F2A44",
"Navy/ Blue Mist": "#1e3a73",
"Navy/ Brown": "#1C1F2A",
"Navy/ Burgundy/ Khaki": "#333e59",
"Navy/ Burnt Orange": "#162631",
"Navy/ Cardinal/ Stone": "#333e59",
"Navy/ Charcoal": "#1C2041",
"Navy/ Columbia": "#1B3E66",
"Navy/ Columbia Blue/ White": "#333e59",
"Navy/ Columbia Plaid": "#2A304E",
"Navy/ Dark Grey": "#062B60",
"Navy/ Dark Grey/ Silver": "#333e59",
"Navy/ Dark Pink": "#333e59",
"Navy/ French Blue": "#333e59",
"Navy/ Gold": "#29283A",
"Navy/ Graphite": "#1F2A44",
"Navy/ Grey": "#29293D",
"Navy/ Grey/ White": "#333e59",
"Navy/ Heather Grey": "#333e59",
"Navy/ Khaki": "#26303C",
"Navy/ Light Blue": "#252A36",
"Navy/ Natural/ Carolina Blue": "#a5bbd8",
"Navy/ Natural/ Red": "#333e59",
"Navy/ Navy": "#222953",
"Navy/ Navy to White Fade": "#333e59",
"Navy/ Navy-Red": "#252A36",
"Navy/ Navy/ Red": "#333e59",
"Navy/ Orange": "#162631",
"Navy/ Orange/ Khaki": "#333e59",
"Navy/ Oxford": "#2A304E",
"Navy/ Oxford Heather": "#2A304E",
"Navy/ Oxford/ White": "#162631",
"Navy/ Postman Blue": "#363840",
"Navy/ Red": "#152D5C",
"Navy/ Red/ White": "#152D5C",
"Navy/ Safety Yellow": "#162631",
"Navy/ Scarlet Red/ Khaki": "#333e59",
"Navy/ Silver Plaid": "#2A304E",
"Navy/ Stone": "#1F2A44",
"Navy/ Stone Stitch": "#333e59",
"Navy/ Stripes": "#333e59",
"Navy/ Texas/ Stone": "#333e59",
"Navy/ USA": "#333e59",
"Navy/ USA Flag": "#333e59",
"Navy/ USA Mesh": "#333e59",
"Navy/ Vanilla": "#303346",
"Navy/ White": "#222953",
"Navy/ White Polka Dots": "#333e59",
"Navy/ White Split": "#333e59",
"Navy/ White Stars": "#333e59",
"Navy/ White/ Grey/ Gold": "#333e59",
"Navy/ White/ Grey/ Red": "#333e59",
"Navy/ White/ Red": "#333e59",
"Navy/ White/ Red Tri": "#333e59",
"Navy/ White/ White": "#252A36",
"Navy/ Yellow/ Khaki": "#1C1F2A",
"Neo Mint": "#A0CFA8",
"Neon Blaze Orange": "#f2724d",
"Neon Blue": "#004EA8",
"Neon Cantaloupe": "#FFBBA4",
"Neon Fuchsia": "#EC2FEE",
"Neon Green": "#A7E163",
"Neon Lemon": "#EFF4A4",
"Neon Lime": "#00D700",
"Neon Orange": "#E5801C",
"Neon Pink": "#E16F8F",
"Neon Rainbow": "#1F5FCD",
"Neon Violet": "#BF9BDE",
"Neon Yellow": "#C6E970",
"Neon Yellow/ White": "#E7E41B",
"New Railroad Grey": "#484649",
"New Timber": "#584834",
"New Timber/ Tan": "#3a3c3a",
"Nickel": "#7E8083",
"Nickel Heather/ Black": "#7E8083",
"Nickel Heather/ Forest Camo": "#7E8083",
"Nickel/ Carbon": "#7E8083",
"Night Owl": "#263147",
"Nightmare": "#1D698D",
"Nile": "#2d333c",
"Nordic Chairlift/ Beige": "#CCBCAD",
"Nude": "#BD9A7A",
"OATMEAL": "#D2CFC4",
"OATMEAL FLECK": "#D6D2C4",
"OATMEAL HEATHER": "#D1CCBD",
"OATMEAL TRIBLEND": "#D6D0AB",
"OATML HT/ SMK HT": "#F0EDE8",
"OATML HT/ VNT NV": "#F0EDE8",
"OATML HTHR/ ARMY": "#F0EDE8",
"OATML HTHR/ RED": "#F0EDE8",
"OC BL/ NV/ OC BL": "#298FC2",
"OCEAN": "#0078A5",
"OCEAN BLUE": "#298FC2",
"OCEAN BLUE HTHR": "#298FC2",
"OCEANBERRY": "#458FBF",
"OCEANBERRY HTHR": "#458FBF",
"OFF WHITE DENIM": "#FFFFFF",
"OLIVE": "#424716",
"OLIVE BLIZZARD": "#5C5C26",
"OLIVE DUCK": "#5A5348",
"OLIVE TRIBLEND": "#726449",
"OLIVE/ BLACK": "#484524",
"OLIVE/ STONE": "#666633",
"OLYM BLU/ CRBN": "#0067B9",
"OLYMPIC RED": "#BC1E37",
"ONYX FLECK": "#3F3F44",
"ONYX/ ELC BLUE": "#353535",
"OPAL BLUE": "#A6B8C1",
"ORANGE": "#FB9133",
"ORANGE TRIBLEND": "#FDA883",
"ORCHID TRIBLEND": "#CC9197",
"ORION": "#595E64",
"OUTDOOR CAMO": "#927370",
"OXBLOOD BLACK": "#291315",
"OXFORD": "#939495",
"OXFORD BLUE": "#D4E7F8",
"OXFORD GRAY": "#9D9B9C",
"OXFORD GREY": "#606B70",
"OXFORD LILAC": "#CAADD9",
"OXFORD ORANGE": "#FDBEB5",
"OXFORD PINK": "#F5C9D8",
"OXFORD YELLOW": "#FCE9C9",
"OXFORD/ BLACK": "#AFACA7",
"OXFORD/ DEEP PUR": "#939495",
"OXFORD/ FOR GRN": "#939495",
"OXFORD/ INDG HTH": "#AFACA7",
"OXFORD/ J NAVY": "#A4A4A6",
"OXFORD/ MINT HTH": "#AFACA7",
"OXFORD/ ROYAL": "#A4A4A6",
"OXFORD/ TRUE RED": "#A4A4A6",
"OXFRD/ F RED HTH": "#939495",
"OXFRD/ IR GRN HT": "#939495",
"OYSTER": "#D0CAB6",
"Oak": "#CCBCAD",
"Oasis Green": "#00774f",
"Oasis Green/ White": "#284734",
"Oatmeal": "#D2CFC4",
"Oatmeal Heather": "#D1CCBD",
"Oatmeal Heather/ Black Ink": "#D1CCBD",
"Oatmeal Heather/ Fiery Red Heather": "#D1CCBD",
"Oatmeal Heather/ Forest Green Heather": "#D1CCBD",
"Oatmeal Heather/ Indigo Heather": "#D1CCBD",
"Oatmeal Heather/ Salt & Pepper Stripe": "#EAE4D4",
"Oatmeal Heather/ Teak": "#f8f3e3",
"Oatmeal Heather/ White": "#D1CCBD",
"Obsidian": "#4D495B",
"Ocean": "#0078A5",
"Ocean Corduroy": "#3474a6",
"Ocean/ Sage": "#01549A",
"Off White": "#F5ECD2",
"Off-White": "#ffffff",
"Offshore Slate": "#8b9b9a",
"Offshore White": "#ffffff",
"Oil Red": "#D82B48",
"Old Wash Black": "#1b151a",
"Old Wash Black/ Black": "#1b151a",
"Old Wash Blue": "#333e59",
"Old Wash Grey": "#848283",
"Old Wash Grey/ Black": "#848283",
"Old Wash Navy/ Grey": "#333e59",
"Olive": "#424716",
"Olive Duck": "#5A5348",
"Olive Gobi": "#214230",
"Olive Green": "#5d5d3d",
"Olive Green/ Black": "#18332F",
"Olive Green/ Khaki": "#807c6c",
"Olive Green/ Navy": "#807c6c",
"Olive Green/ Silver": "#18332F",
"Olive Green/ Stone": "#5d5d3d",
"Olive Green/ Tan": "#5d5d3d",
"Olive Grey": "#554F3F",
"Olive Heather": "#344512",
"Olive Heathered": "#818f84",
"Olive Night": "#807c6c",
"Olive Oil": "#899064",
"Olive Slub/ Black": "#5d5d3d",
"Olive Tie Dye": "#767555",
"Olive Z - Quilted": "#807c6c",
"Olive/ Black": "#484524",
"Olive/ Camo": "#807c6c",
"Olive/ Dark Olive/ Dark Khaki": "#807c6c",
"Olive/ Grey": "#00523e",
"Olive/ Grey/ Grey Camo": "#807c6c",
"Olive/ Hardwoods": "#3a3c3a",
"Olive/ Khaki": "#51695d",
"Olive/ Khaki Stars": "#18332F",
"Olive/ Khaki USA": "#18332F",
"Olive/ Realtree AP": "#807c6c",
"Olive/ Stone Stitch": "#807c6c",
"Olive/ Woodland": "#4E4934",
"Ombre Blue/ Navy": "#3474a6",
"Onyx Black": "#000000",
"Opal Blue": "#A6B8C1",
"Orange": "#FB9133",
"Orange Fluorescent": "#FF5C39",
"Orange Heather": "#ea542a",
"Orange Tea": "#e25d3e",
"Orange/ Black": "#ea5826",
"Orange/ Grey": "#e25d3e",
"Orange/ Khaki": "#e25d3e",
"Orange/ Stone": "#e25d3e",
"Orange/ White": "#ea5826",
"Orchid": "#D5BEDA",
"Orchid Ice": "#D358F7",
"Orchid/ Grey": "#D358F7",
"Overland Heather": "#8C8575",
"Oxford": "#939495",
"Oxford Heather": "#98979A",
"Oxford Heather/ White": "#98979A",
"Oxford/ Black": "#AFACA7",
"Oxford/ Black/ White": "#97999b",
"Oxford/ Burnt Orange": "#97999b",
"Oxford/ Forest": "#97999b",
"Oxford/ Kelly": "#97999b",
"Oxford/ Maroon": "#97999b",
"Oxford/ Navy": "#97999b",
"Oxford/ Purple": "#97999b",
"Oxford/ Red": "#97999b",
"Oxford/ Royal": "#A4A4A6",
"Oxford/ White": "#ACACAC",
"PACIFIC BLUE": "#38B8FF",
"PALE PINK": "#FBD7E3",
"PALE YLW TRBLND": "#F3DFA0",
"PALM GREEN": "#007A3D",
"PALM PARADISE": "#FAFAFC",
"PAPAYA/ WHITE": "#FF8674",
"PARROT RED": "#992135",
"PEACH": "#F6C2AC",
"PEACH SLUB": "#F3B69A",
"PEACH TRIBLEND": "#E7BDA4",
"PEBBLE": "#826962",
"PEONY PINK": "#F2B5CB",
"PEONY PK/ DP PNK": "#C92D52",
"PEPPER": "#30383A",
"PEPPER BLACK": "#B2B2B4",
"PEPPER FRST GRN": "#B2B2B4",
"PEPPER MAROON": "#B2B2B4",
"PEPPER NAVY": "#B2B2B4",
"PEPPER RED": "#B2B2B4",
"PEPPER ROYAL": "#B2B2B4",
"PERI BLUE": "#236192",
"PERIWINKLE BLUE": "#7D96D8",
"PINE": "#01420C",
"PINEAPPLE": "#F7E8AA",
"PINK": "#FAD4E1",
"PINK TRIBLEND": "#FFC6D4",
"PINK WOODLAND": "#FCA9D3",
"PINK/ SILVER": "#E8B3C3",
"PINK/ WHITE": "#F2D4D7",
"PISTACHIO": "#779853",
"PITCH BLACK MIST": "#2C2B2C",
"PLATINUM": "#D6D6CD",
"PLATNM/ CRBN": "#C1C6C8",
"PLATNM/ OLY BLU": "#D8D8D6",
"PLUM": "#663262",
"PLUM/ SILVER": "#533154",
"PLUMROSE": "#E7A9C2",
"POOL BLUE": "#3BB5CF",
"POPPY": "#FE342A",
"POWER BLUE": "#0085BA",
"POWER PINK": "#CD0C6E",
"PREMIUM HEATHER": "#8D8D95",
"PURPLE": "#4D2379",
"PURPLE BERRY": "#9A6AA6",
"PURPLE PLM RAISN": "#A56E96",
"PURPLE RUSH": "#5A3D94",
"PURPLE SNOW HTH": "#502D7F",
"PURPLE TRIBLEND": "#AD63DB",
"PURPLE/ TAN": "#7379B3",
"PURPLE/ WHITE": "#4D2379",
"PUTTY": "#DDCCA5",
"PW PNK/ SLT/ WHT": "#CD0C6E",
"Pacific": "#234156",
"Pacific Blue": "#38B8FF",
"Pacific Tropical": "#3474a6",
"Pale Banana/ Birch": "#fced00",
"Pale Khaki/ Loden Green": "#CCBCAD",
"Pale Peach/ Maroon": "#E29F81",
"Pale Pink": "#FBD7E3",
"Pale Yellow": "#F5E1A4",
"Paprika": "#CA3606",
"Paradise Pink": "#F67599",
"Parchment": "#dACEC0",
"Pastel": "#F633CF",
"Pastel Rainbow": "#00BFFF",
"Pastel Ripple": "#1D698D",
"Pastel Tie Dye/ Navy/ Khaki": "#333e59",
"Patina": "#97999B",
"Patina Green/ Birch": "#00774f",
"Peach": "#F6C2AC",
"Peach Heather": "#ECC3B2",
"Peach/ Stone": "#e25d3e",
"Peachy": "#d46c36",
"Peacoat Navy": "#6b6977",
"Peacock": "#87ADB0",
"Pelican Light Grey": "#A2A7A1",
"Pepper": "#30383A",
"Peri Blue Heather": "#4682B4",
"Periwinkle": "#49506a",
"Periwinkle Tie Dye": "#CCCCFF",
"Periwinkle/ Floral": "#49506a",
"Persian Red/ Navy": "#ac1c26",
"Petrol": "#333e59",
"Petrol Blue": "#6e85b7",
"Pewter": "#514C50",
"Phoenix Heathered": "#f19035",
"Photo": "#828389",
"Picante Pink": "#db1573",
"Pigment Alpine Green": "#5A7B7E",
"Pigment Aqua": "#7BC8D0",
"Pigment Army": "#344512",
"Pigment Black": "#4B4B4B",
"Pigment Brown": "#6b4a35",
"Pigment Burro": "#7A6855",
"Pigment Cement": "#9E9897",
"Pigment French Oak": "#d8B589",
"Pigment Grape Ice": "#464E7E",
"Pigment Ivory": "#E3E0DC",
"Pigment Light Blue": "#97B6E0",
"Pigment Lunar Rock": "#464E7E",
"Pigment Maroon": "#A45F77",
"Pigment Midnight Navy": "#191970",
"Pigment Mint": "#91C7CB",
"Pigment Mustard Yellow": "#c68a32",
"Pigment Navy": "#333e59",
"Pigment Oil Green": "#74913d",
"Pigment Olive Green": "#807c6c",
"Pigment Peanut Butter": "#7A6855",
"Pigment Pebble Blue": "#6787B7",
"Pigment Pink": "#FEA9BE",
"Pigment Pistachio": "#A9C47F",
"Pigment Red": "#b62730",
"Pigment Royal": "#3474a6",
"Pigment Salmon": "#f5ac94",
"Pigment Sandstone": "#CDB79F",
"Pigment Slate Blue": "#5C7491",
"Pigment Stone": "#E1D9C5",
"Pigment Tan": "#c8af93",
"Pigment Teal": "#1E6B7F",
"Pigment Texas Orange": "#A65523",
"Pigment Tornado": "#7d7d7d",
"Pigment Yellow": "#F9DE92",
"Pina Colada": "#F4D1A1",
"Pine": "#01420C",
"Pink": "#FAD4E1",
"Pink - B126": "#ef6b8d",
"Pink Camo": "#c0869b",
"Pink Lady": "#d63888",
"Pink Lemonade": "#F04E98",
"Pink Lemonade Mist": "#E06287",
"Pink Realtree AP": "#ffbdc5",
"Pink Seersucker": "#ffbdc5",
"Pink Sorbet/ Floral": "#DB3E79",
"Pink Sorbet/ Floral/ Pink Sorbet": "#DB3E79",
"Pink/ Dark Pink": "#ee344b",
"Pink/ Stone": "#ffbdc5",
"Pink/ White": "#F2D4D7",
"Pitch Black": "#1E1E20",
"Pitch Black Mist": "#2C2B2C",
"Placid Blue": "#B0C0D6",
"Platinum": "#D6D6CD",
"Platinum Heather": "#C1C6C8",
"Plein Air": "#97999B",
"Plum": "#663262",
"Polar Blue": "#A5B3CC",
"Polar Heather": "#A4C8E1",
"Polka Dot": "#000000",
"Pomegranate": "#CC4855",
"Poncho": "#284734",
"Pool Blue": "#3BB5CF",
"Poppy Red": "#f52626",
"Porcelain": "#D7d2cb",
"Port": "#70383E",
"Postman Blue": "#324461",
"Powder Blue": "#CFE6F6",
"Powder Blue/ Navy": "#3474a6",
"Powder Blue/ White": "#0076A8",
"Power Blue": "#0085BA",
"Power Pink": "#CD0C6E",
"Power Pink/ White": "#ca468a",
"Prepared For Dye": "#e7e8e7",
"Prescott Yellow": "#ED9903",
"Prism": "#d50032",
"Prym1 Amped Green/ Black": "#000000",
"Prym1 Voltage Yellow/ Black": "#000000",
"Pumpkin": "#963821",
"Pure White": "#E0E1DC",
"Purist Blue": "#647692",
"Purple": "#4D2379",
"Purple - B129": "#000000",
"Purple Heather": "#3c3a7a",
"Purple Mcintosh Plaid": "#482D54",
"Purple Passion": "#3a385e",
"Purple Ranges/ Lavendar Sophia G": "#351F65",
"Purple Rush": "#5A3D94",
"Purple Storm": "#75726f",
"Purple Tonal Blend": "#3b3669",
"Purple/ Black": "#363669",
"Purple/ Black/ White": "#3a385e",
"Purple/ Gold": "#3a385e",
"Purple/ Graphite": "#363669",
"Purple/ Grey": "#491c58",
"Purple/ Heather": "#351F65",
"Purple/ Khaki": "#3a385e",
"Purple/ Natural/ Lavender": "#aab3d7",
"Purple/ Rainbow": "#491c58",
"Purple/ Stone": "#3a385e",
"Purple/ White": "#4D2379",
"Purple/ White Plaid": "#482D54",
"Putty": "#DDCCA5",
"Putty/ Navy/ Navy": "#cdc4aa",
"Putty/ White": "#CAC0AB",
"Pyro Heathered": "#8A2232",
"QUARRY STRIPE": "#A2AAAD",
"Quartz": "#9D848E",
"RASPBERRY": "#E47FA7",
"RASPBERRY/ R DOT": "#EF60A3",
"RD/ RD WH ST/ WH": "#EF60A3",
"REACTIVE RAINBOW": "#EBE338",
"REAL TREE EDGE": "#7F7B70",
"REALTREE AP": "#8F714D",
"REALTREE APG": "#46471D",
"REALTREE X/ CHAR": "#9F8A6C",
"RED": "#B2000D",
"RED BLIZZARD": "#BA0C2F",
"RED CABANA": "#AA2029",
"RED FLECK": "#9F2D3E",
"RED FLECK/ RED": "#CE1126",
"RED HEATHER": "#A6192E",
"RED MIST": "#F35D69",
"RED PEPPER": "#C43F54",
"RED PEPPER HTHR": "#9F232D",
"RED SNOW HEATHER": "#A7192D",
"RED STAR": "#EA4251",
"RED TRBLN BUFLO": "#633039",
"RED TRIBLEND": "#B40317",
"RED WHT STR/ WHT": "#A6192E",
"RED/ BLACK": "#CC0404",
"RED/ BLK BUFFALO": "#D33432",
"RED/ CHRCOAL FLK": "#CE1126",
"RED/ DARK GREY": "#BA0C2F",
"RED/ H BLACK": "#A21630",
"RED/ NAVY": "#BA0C2F",
"RED/ NAVY/ RED": "#A6192E",
"RED/ RED DOT": "#A6192E",
"RED/ SLATE/ WHT": "#CD2338",
"RED/ TTNIUM/ WHT": "#A6192E",
"RED/ WHITE": "#FFFFFF",
"RED/ WHITE/ BLK": "#E4002B",
"RED/ WHITE/ BLUE": "#E51B39",
"RED/ WHITE/ WHT": "#C40D24",
"RED/ WHT/ RED": "#E51B39",
"RETRO HTHR ROYAL": "#34679E",
"ROPE": "#C1B0A0",
"ROSE BLOOM": "#C88C8E",
"ROSE QUARTZ": "#EBDFDF",
"ROUGE": "#8E3950",
"ROYAL": "#0079DB",
"ROYAL BLIZZARD": "#003DA5",
"ROYAL BLK TRBLND": "#38659E",
"ROYAL BLUE": "#1D4F91",
"ROYAL COBALT": "#00529B",
"ROYAL FLECK": "#506086",
"ROYAL FLK/ BLACK": "#0038A8",
"ROYAL FLK/ ROYAL": "#0038A8",
"ROYAL HEATHER": "#4A649F",
"ROYAL MIST": "#326295",
"ROYAL PEPPER": "#5C75AE",
"ROYAL PINE": "#537C76",
"ROYAL POLKA DOT": "#065EB0",
"ROYAL SNOW HTHR": "#416BA9",
"ROYAL STAR": "#577AE4",
"ROYAL TRIBLEND": "#394694",
"ROYAL/ CHARCOAL": "#1E4DAE",
"ROYAL/ GOLD": "#234B8A",
"ROYAL/ HTHR GRAY": "#234B8A",
"ROYAL/ NAVY": "#0079DB",
"ROYAL/ RED/ WHT": "#00508F",
"ROYAL/ TAN": "#425286",
"ROYAL/ TTNM/ WHT": "#1D4289",
"ROYAL/ WHITE": "#FFFFFF",
"ROYAL/ WHT/ ROYL": "#171CBD",
"ROYAL/ WHT/ WHT": "#0079DB",
"ROYL/ CHRCL FLK": "#0038A8",
"RPSTP DG GR CAMO": "#CAAE87",
"RPSTP TIGER CAMO": "#66614D",
"RS SPORT GREY": "#97999B",
"RUBY": "#B70C26",
"RUSSIAN BLUE": "#31364A",
"RUST": "#CF523E",
"RYL BLK/ BLK TRB": "#38659E",
"Rainbow": "#3C8BC6",
"Rainbow Stripe": "#d4c766",
"Rainbow Tide": "#1D698D",
"Rainbow Tie Dye/ Navy/ Khaki": "#333e59",
"Rainbow Tie-Dye": "#ffffff",
"Ranges Grey/ Dark Orange": "#e25d3e",
"Raspberry Mist": "#ffbdc5",
"Realtree AP Green": "#716955",
"Realtree AP/ Brown": "#3f452b",
"Realtree AP/ Neon Orange": "#6b5742",
"Realtree AP/ Neon Yellow": "#6b5742",
"Realtree AP/ Tan": "#6b5742",
"Realtree Advantage/ Khaki": "#B59F88",
"Realtree All Purpose": "#79614D",
"Realtree Apx": "#6b5742",
"Realtree Edge": "#6b5742",
"Realtree Edge/ Brown": "#6b5742",
"Realtree Edge/ Neon Orange": "#32572b",
"Realtree Edge/ Neon Pink": "#32572b",
"Realtree Edge/ Neon Yellow": "#32572b",
"Realtree Edge/ Stone": "#4E4934",
"Realtree Escape/ Black": "#32572b",
"Realtree Fishing Blue": "#305791",
"Realtree Fishing Blue/ White": "#3a3c3a",
"Realtree Fishing Light Blue/ Navy": "#32572b",
"Realtree Fishing Light Blue/ White": "#32572b",
"Realtree Hardwood HD": "#6E5D50",
"Realtree Hardwoods/ Black": "#6E5D50",
"Realtree Max 5": "#6b5742",
"Realtree Max 5/ Tan": "#6b5742",
"Realtree Max 7/ Buck": "#6b5742",
"Realtree Max-1/ Brown": "#6b5742",
"Realtree Max-5": "#6b5742",
"Realtree Max-7/ Buck": "#32572b",
"Realtree Max4": "#3a3c3a",
"Realtree Original/ Black": "#6b5742",
"Realtree Timber/ Black": "#6b5742",
"Realtree Xtra": "#64625b",
"Recycled Black": "#000000",
"Recycled Natural": "#E5D3BF",
"Red": "#B2000D",
"Red - B122": "#FF0000",
"Red Buffalo": "#AB1F3A",
"Red Buffalo Plaid": "#C10933",
"Red Heather": "#A6192E",
"Red Heather/ Birch": "#f80808",
"Red Henna": "#96262f",
"Red Mist": "#F35D69",
"Red Paisley": "#f80808",
"Red Pepper": "#C43F54",
"Red Stripe/ Khaki": "#e11f48",
"Red Tonal Blend": "#a0202c",
"Red/ Black": "#CC0404",
"Red/ Black Buffalo": "#AE0F36",
"Red/ Black/ White": "#ee344b",
"Red/ Charcoal": "#ee344b",
"Red/ Charcoal/ Black": "#ee344b",
"Red/ Charcoal/ Black Tri": "#ee344b",
"Red/ Gold": "#ee344b",
"Red/ Graphite": "#f2000c",
"Red/ Khaki": "#C8102E",
"Red/ Leopard": "#f80808",
"Red/ Light Orange": "#BC2235",
"Red/ Lime": "#000000",
"Red/ Lime - B203": "#FF0000",
"Red/ Maroon": "#f80808",
"Red/ Navy": "#BA0C2F",
"Red/ Oxford": "#CE1126",
"Red/ Oxford/ White": "#a0202c",
"Red/ Red": "#b62730",
"Red/ Stone": "#f80808",
"Red/ Tan": "#b62730",
"Red/ USA": "#b62730",
"Red/ USA Flag": "#ee344b",
"Red/ USA Mesh": "#b62730",
"Red/ White": "#FFFFFF",
"Red/ White Polka Dots": "#f80808",
"Red/ White Stars": "#f80808",
"Red/ White/ Grey/ Black": "#ee344b",
"Red/ White/ Royal": "#ee344b",
"Reef": "#69B3E7",
"Robins Egg": "#A4C8E1",
"Rock": "#888B8D",
"Rock/ Camo": "#4c4846",
"Rolling Mountains": "#6b4a35",
"Rope": "#C1B0A0",
"Rose": "#FFC0CB",
"Rose Crystal": "#FFC0CB",
"Rose Quartz": "#EBDFDF",
"Rose Tie Dye": "#e3bec3",
"Rose/ Cream": "#c0869b",
"Rose/ Polka Dots": "#ffbdc5",
"Rosewood/ Vanilla": "#c0869b",
"Rosin": "#2e3b35",
"Rouge": "#8E3950",
"Royal": "#0079DB",
"Royal (disc)": "#224D8F",
"Royal Blue": "#1D4F91",
"Royal Blue - B121": "#0000FF",
"Royal Blue/ Black": "#22569c",
"Royal Blue/ Lime": "#000000",
"Royal Blue/ Lime - B202": "#0000FF",
"Royal Buffalo": "#215994",
"Royal Gold": "#EBBC4E",
"Royal Heather": "#4A649F",
"Royal Melange": "#2C5697",
"Royal Mist": "#326295",
"Royal Pine": "#537C76",
"Royal Tonal Blend": "#1c4681",
"Royal/ Black": "#1D4F91",
"Royal/ Black Buffalo": "#1B5091",
"Royal/ Black/ White": "#305791",
"Royal/ Charcoal": "#1E4DAE",
"Royal/ Charcoal/ Black Tri": "#305791",
"Royal/ Floral": "#3474a6",
"Royal/ Gold": "#234B8A",
"Royal/ Graphite": "#1c4681",
"Royal/ Grey": "#3474a6",
"Royal/ Khaki": "#333e59",
"Royal/ Light Heather Grey": "#3474a6",
"Royal/ Mustard/ Stone": "#305791",
"Royal/ Nantucket/ Grey": "#374158",
"Royal/ Navy": "#0079DB",
"Royal/ Orange": "#425ba9",
"Royal/ Oxford": "#0038A8",
"Royal/ Oxford/ White": "#1c4681",
"Royal/ Red": "#1D4289",
"Royal/ Royal": "#3474a6",
"Royal/ Silver Plaid": "#1B5091",
"Royal/ Stone": "#305791",
"Royal/ White": "#FFFFFF",
"Royal/ White/ Grey": "#305791",
"Royal/ White/ Red": "#305791",
"Ruby": "#B70C26",
"Rust": "#CF523E",
"Rustic Trees/ Olive Green": "#807c6c",
"Rusty": "#76432a",
"S ORANGE": "#F17425",
"SADDLE": "#92653C",
"SAFETY GREEN": "#C4D600",
"SAFETY ORANGE": "#FF983A",
"SAFETY PINK": "#E06287",
"SAFETY YELLOW": "#E3E829",
"SAGE": "#988557",
"SALTWATER": "#7F8BA3",
"SAND": "#C5B9AC",
"SAND DIGITAL": "#7D5742",
"SAND/ GRAY": "#CFC6BD",
"SANTA FE RED": "#CF2E33",
"SANTORINI": "#69A2E5",
"SAPPHIRE": "#007DBA",
"SAPPHIRE HEATHER": "#B1D6E9",
"SAPPHIRE STRIPE": "#001E62",
"SATURN": "#BAD5F7",
"SCARLET/ WHITE": "#AE1C30",
"SCUBA BLUE": "#47C7C7",
"SD DARK GRY TRBL": "#5E575E",
"SEA": "#304C7B",
"SEA FOAM": "#7ECECB",
"SEA FROST": "#BAE2DA",
"SEA GLASS GREEN": "#66E0D5",
"SEAFOAM": "#79A9AA",
"SEATTLE GREY": "#63666A",
"SEERSUCKER": "#EFF4F8",
"SFTY YLW/ CRBN": "#E3E829",
"SHERBERT": "#CAC188",
"SHIRAZ": "#BA7177",
"SILK": "#CFC4BE",
"SILVER": "#B0B6B6",
"SILVER BLIZZARD": "#E4E0E2",
"SILVER CAMO": "#B3B8B1",
"SILVER GRY TRBLN": "#C7CCD2",
"SILVER HEATHER": "#7C878E",
"SILVER/ WHITE": "#B4BBBF",
"SKY": "#99BDDF",
"SKY BLUE": "#8DC8E8",
"SLATE TRIBLEND": "#302F35",
"SLD DK GRY TRBLN": "#555155",
"SLD WHT/ S BL TB": "#FFFFFF",
"SLT/ ATH HTH/ WH": "#29353C",
"SMK GRY/ VT COAL": "#D4C6C3",
"SMOK TRBLN BUFLO": "#605E61",
"SMOKE": "#3E3A36",
"SMOKE GRAY": "#3F3F38",
"SMOKE HEATHER": "#60605B",
"SMOKE MELANGE": "#786C6C",
"SMOKE STAR": "#4C4A4C",
"SMOKE TRIBLEND": "#969696",
"SMOKE/ BLACK": "#A29F98",
"SMOKE/ BLGRS/ KH": "#444F51",
"SMOKE/ CHRCL HT": "#A29F98",
"SMOKE/ SMPLY RED": "#A29F98",
"SMOKE/ VIN NAVY": "#A29F98",
"SMOKE/ VIN ROYAL": "#A29F98",
"SMOKED PAPRIKA": "#D85656",
"SNOW HEATHER RED": "#FEE2E1",
"SNOW HEATHR BLUE": "#E1EEFE",
"SNOW HEATHR GRAY": "#B1B1B1",
"SNOW HTHR GREEN": "#BED2D3",
"SNOW HTHR INDIGO": "#B5BDD0",
"SO ORNG/ WHT/BLK": "#FF704D",
"SOL BLACK TRBLND": "#000000",
"SOLID BLACK": "#000000",
"SOLID BLACK SLUB": "#101820",
"SOLID BLACK TRBL": "#000000",
"SOLID BLK BLEND": "#000000",
"SOLID BLK TRBLND": "#000000",
"SOLID NAVY TRBLN": "#303245",
"SOLID NVY TRBLND": "#2A3352",
"SOLID WHITE TRBL": "#FFFFFF",
"SOLID WHT BLEND": "#FFFFFF",
"SOLID WHT TRBLND": "#FFFFFF",
"SOUTHERN ORANGE": "#F0874E",
"SP ATH GOLD/ WHT": "#EBAC20",
"SP ATHLETIC GOLD": "#FFB500",
"SP CHARITY PINK": "#C6579A",
"SP DARK MAROON": "#572932",
"SP DK NAVY/ WHT": "#052241",
"SP DRK NVY HTH": "#0C2340",
"SP FOREST HTHR": "#115740",
"SP FOREST/ WHITE": "#015643",
"SP GRAPHITE/ WHT": "#5B5B5B",
"SP LT BLUE/ WHT": "#649DC7",
"SP MAROON HTHR": "#6F263D",
"SP MAROON/ WHITE": "#580C33",
"SP PURPLE/ WHITE": "#502E7E",
"SP RED HEATHER": "#BA0C2F",
"SP ROYAL HEATHER": "#003087",
"SP ROYAL/ WHITE": "#1A417E",
"SP SCARLET RED": "#B51320",
"SP SILVER/ WHITE": "#D7D7D7",
"SPANISH MOSS": "#77A9A8",
"SPIDER BABY BLUE": "#B3E9FB",
"SPIDER BLACK": "#71717F",
"SPIDER GOLD": "#F0D163",
"SPIDER LIME": "#DBEEC7",
"SPIDER NAVY": "#768BB4",
"SPIDER ORANGE": "#F9C06B",
"SPIDER PINK": "#FD9FBC",
"SPIDER PURPLE": "#A994CD",
"SPIDER RED": "#D4282A",
"SPIDER ROYAL": "#85BCF0",
"SPIDER TURQUOISE": "#8AC8D2",
"SPORT ATH GOLD": "#EBAC20",
"SPORT BNRT ORNGE": "#A25224",
"SPORT CHARITY PK": "#CB5F9B",
"SPORT CHRTY PINK": "#CB5F9B",
"SPORT DARK BROWN": "#4E3629",
"SPORT DARK GREEN": "#2C5234",
"SPORT DARK NAVY": "#00263A",
"SPORT FOREST": "#115740",
"SPORT GRAPHITE": "#75787B",
"SPORT GREY": "#97999B",
"SPORT GREY/ BLK": "#97999B",
"SPORT GREY/ NAVY": "#97999B",
"SPORT GREY/ RED": "#97999B",
"SPORT GRY/ ROYAL": "#97999B",
"SPORT KELLY": "#007A53",
"SPORT LIGHT BLUE": "#6A9FD5",
"SPORT MAROON": "#6F263D",
"SPORT ORANGE": "#EF4E26",
"SPORT PURPLE": "#582C83",
"SPORT RED": "#BA0C2F",
"SPORT RED/ WHITE": "#BC1F35",
"SPORT ROYAL": "#002D72",
"SPORT SILVER": "#B4B7B5",
"SPORT VEGAS GOLD": "#CAB380",
"SPRING YELLOW": "#EADA7F",
"SPRT SCARLET RED": "#BA0C2F",
"SPRUCE": "#28571D",
"SPT SFTY ORANGE": "#F4A400",
"SPT SFTY YELLOW": "#D9E23C",
"SQUASH": "#ECCA4F",
"STARS": "#E1E0C2",
"STAY GOLD": "#F7A947",
"STEALTH": "#5B5B5B",
"STEEL GREY": "#424247",
"STEEL/ BLACK": "#425563",
"STEEL/ WHITE": "#BDBDC7",
"STONE": "#E4DBC6",
"STONE GRAY": "#6C6C70",
"STONE/ BLACK": "#E4DBC6",
"STONE/ CYPRESS": "#E2E2E2",
"STONE/ FOREST": "#C0AF9F",
"STONE/ ROYAL": "#C0AF9F",
"STONE/ WHITE": "#BCB69C",
"STONEWASH BLUE": "#7987A2",
"STONEWASH GREEN": "#BFD1C3",
"STORM": "#948D95",
"STORM TRIBLEND": "#9892A0",
"SUMMER SKY BLUE": "#04A3E5",
"SUMMER SQUASH": "#FEDEA1",
"SUNSET GOLD": "#F6CE6E",
"SUNSET TRIBLEND": "#ED9B83",
"SYNTHETIC GREEN": "#60E68F",
"Sable Duck Camo/ Black": "#32572b",
"Saddle": "#92653C",
"Saddle Mesh": "#794820",
"Saddle/ Duck Camo": "#794820",
"Safety Green": "#C4D600",
"Safety Orange": "#FF983A",
"Safety Yellow": "#E3E829",
"Safety Yellow Green/ Graphite": "#dcff00",
"Saffron/ Camo": "#000000",
"Sage": "#988557",
"Sage Corduroy": "#8BAA99",
"Sage Green Heather": "#3E5045",
"Sage/ Polka Dots": "#706863",
"Sail Blue": "#3474a6",
"Salt & Pepper": "#77787B",
"Salt and Pepper": "#ffffff",
"Saltwater": "#7F8BA3",
"Saltwater Duck Camo/ Charcoal": "#32572b",
"Sand": "#C5B9AC",
"Sand Gobi": "#CEB3A6",
"Sandstone": "#D1B898",
"Sangria Blackout": "#6a252f",
"Santorini": "#69A2E5",
"Sapphire": "#007DBA",
"Sargasso Sea": "#487A7B",
"Saturn": "#BAD5F7",
"Sawgrass": "#708573",
"Sawgrass Corduroy/ Brown": "#ab9c91",
"Scarlet": "#831D2B",
"Scarlet Red/ Grey": "#f80808",
"Scarlet Red/ Khaki": "#e11f48",
"Scarlet Red/ Navy": "#333e59",
"Scarlet Red/ Navy/ Khaki": "#e11f48",
"Scarlet Red/ White": "#A6192E",
"Scarlet/ Black": "#C81818",
"Scottish Tartan Plaid": "#2b3852",
"Scuba": "#00a8dd",
"Sea Blue": "#002C56",
"Sea Blue/ White": "#004976",
"Sea Breeze": "#B1E4E3",
"Sea Glass": "#008E85",
"Sea Green": "#78C7B9",
"Sea Green/ White": "#A0B2CD",
"Seafoam": "#79A9AA",
"Seafoam Heathered": "#87d8c3",
"Seafoam Tri Blend": "#528b82",
"Seafoam/ White": "#95e1c8",
"Seaglass": "#285780",
"Seaglass/ White": "#95e1c8",
"Set Sail": "#7ba4db",
"Shadow": "#454545",
"Shadow Grass": "#715842",
"Shadow Grass Habitat/ Brown": "#6b5742",
"Shadow Stripe": "#464041",
"Shark Grey": "#b1aca8",
"Sherbet": "#c5b4e3",
"Sherbet/ Stripes": "#e25d3e",
"Shiitake": "#8C8279",
"Sienna/ Wheat/ Navy": "#eba857",
"Silver": "#B0B6B6",
"Silver Grey": "#DDDBD1",
"Silver Melange": "#97999B",
"Silver/ Graphite": "#aab3ae",
"Silver/ Grey Camo": "#b1aca8",
"Silverblue Heather": "#97999B",
"Siren": "#d46c36",
"Sky": "#99BDDF",
"Sky Blue": "#8DC8E8",
"Sky Blue Heather": "#8fb1dc",
"Sky Blue/ Stone": "#8AB7CE",
"Sky Heather": "#B8C6E4",
"Sky Heathered": "#a5c5d9",
"Sky Tie Dye": "#98B6E4",
"Skye Blue": "#A5B8D0",
"Slate": "#9F9481",
"Slate Blue": "#7A95B3",
"Slate Blue/ Cinder": "#373f41",
"Slate Blue/ Navy Rope": "#326295",
"Slate Green": "#393C47",
"Slate/ Black/ Black/ Cow": "#8FA3A4",
"Slushie Classic": "#1D698D",
"Smoke": "#3E3A36",
"Smoke Blue": "#62717c",
"Smoke Blue/ Aluminum": "#305791",
"Smoke Grey": "#3E3637",
"Smoke/ Graphite": "#D7D7D7",
"Smoked Paprika": "#D85656",
"Smokey Blue": "#b1b9d6",
"Snap Dragon": "#FF6347",
"Snow Camo": "#e3e7ed",
"Snow Leopard": "#e3e7ed",
"Snow Leopard/ White": "#ffffff",
"Snowcone Blue": "#9cbfe2",
"Soft Blue": "#BDD6E6",
"Soft Pine": "#32572b",
"Soft Pink": "#F2D6D8",
"Soft Purple": "#B8ABD0",
"Soft Yellow": "#E0B431",
"Solid Baby Blue Blend": "#89B2C4",
"Solid Black Blend": "#2D2926",
"Solid Black Tri Blend": "#000000",
"Solid Charcoal": "#717374",
"Solid Kelly Blend": "#007c55",
"Solid Natural Blend": "#f6e9d6",
"Solid Navy Blend": "#2c3649",
"Solid Pink Blend": "#f4bed0",
"Solid Red Blend": "#ad132a",
"Solid White Blend": "#FFFFFF",
"Soothing Blue": "#E1F3FF",
"Sorbet": "#F7C995",
"Soul Blue Heather": "#007DBA",
"Southwest": "#ffffff",
"Space": "#1D698D",
"Spearmint": "#6DCDB8",
"Spearmint/ Navy": "#1E6B7F",
"Spindrift": "#777777",
"Sport Athletic Gold": "#FFA300",
"Sport Dark Navy": "#00263A",
"Sport Dark Navy Heather": "#263147",
"Sport Dark Navy Heather/ Sport Graphite": "#263147",
"Sport Dark Navy/ Sport Graphite": "#263147",
"Sport Forest": "#115740",
"Sport Forest Heather/ Sport Graphite": "#273B33",
"Sport Graphite": "#75787B",
"Sport Graphite/ Black": "#707372",
"Sport Grey": "#97999B",
"Sport Light Blue": "#6A9FD5",
"Sport Maroon": "#6F263D",
"Sport Maroon Heather/ Sport Graphite": "#6D273C",
"Sport Orange": "#EF4E26",
"Sport Purple": "#582C83",
"Sport Red": "#BA0C2F",
"Sport Red Heather/ Sport Graphite": "#BA0C2F",
"Sport Red/ Black": "#BA0C2F",
"Sport Red/ Black Heather": "#BA0C2F",
"Sport Royal": "#002D72",
"Sport Royal Heather": "#224D8F",
"Sport Royal Heather/ Sport Graphite": "#224D8F",
"Sport Royal/ Sport Dark Navy": "#224D8F",
"Sport Vegas Gold": "#CAB380",
"Sports Green": "#394E47",
"Spruce": "#28571D",
"Spruce Green": "#284734",
"Spruce/ Birch/ Light Navy": "#3c5148",
"Stardust": "#fced00",
"Starry Night": "#69B3E7",
"Stealth": "#5B5B5B",
"Steel": "#777777",
"Steel Blue": "#4F5A64",
"Steel Grey": "#424247",
"Steel Grey Heather": "#6d6e6b",
"Steelhead": "#777777",
"Stone": "#E4DBC6",
"Stone Blue": "#7E93A7",
"Stone Camo": "#b4aa9c",
"Stone Heather": "#F3F0EB",
"Stone Heathered": "#b4aa9c",
"Stone Khaki": "#CCBCAD",
"Stone Khaki/ Stone": "#CCBCAD",
"Stone/ Black": "#E4DBC6",
"Stone/ Bronze/ Light Olive Green": "#B59F88",
"Stone/ Brown": "#E1D9C5",
"Stone/ Camel/ Brown": "#E1D9C5",
"Stone/ Dark Green": "#E1D9C5",
"Stone/ Khaki": "#D6D2C4",
"Stone/ Light Olive/ White": "#65665C",
"Stone/ Maroon": "#E1D9C5",
"Stone/ Moss/ Charcoal": "#C7B99D",
"Stone/ Navy": "#E1D9C5",
"Stone/ Olive/ Navy": "#E1D9C5",
"Stone/ Stone": "#DAD6CD",
"Stonewash Denim": "#A4ACB9",
"Storm": "#948D95",
"Storm Blue": "#5C6D87",
"Storm Camo": "#202022",
"Storm Grey": "#253C4E",
"Storm Heather": "#8ca5bb",
"Stormy Ash": "#dcdddb",
"Stormy Night": "#e3e0df",
"Sugarplum": "#E6E6FA",
"Summer Green": "#92BF55",
"Sunbeam": "#f3eaa1",
"Sunglow": "#f5e19e",
"Sunkissed Peach/ Birch": "#E29F81",
"Sunray Yellow": "#FFCC38",
"Sunrise": "#fced00",
"Sunset": "#FECCAB",
"Sunset Hills/ Teal": "#1E6B7F",
"Sunset Tie Dye": "#F98E6D",
"Sunset Yellow/ Polka Dots": "#feeab2",
"Sunshine Yellow": "#F3EA5D",
"Sunshine/ White": "#F3EA5D",
"Surf Blackout": "#00859d",
"Surf Green Heather": "#48D1CC",
"Sweet Cream Heather": "#DDCBA4",
"Sweetheart": "#c795a8",
"TACTICAL GREEN": "#6B6E59",
"TAHITI BLUE": "#79CFE8",
"TAN": "#CFB59E",
"TAN TRIBLEND": "#BDB09F",
"TANGERINE": "#F47B20",
"TANGERINE ORANGE": "#F08223",
"TEAK": "#785135",
"TEAL": "#1BA4D0",
"TEAL ICE": "#B1E4E3",
"TEAL TRIBLEND": "#1A9799",
"TEAL/ TAN": "#0A8493",
"TEAL/ WHITE": "#0A8493",
"TEAM ORANGE": "#EE470A",
"TEAM PURPLE": "#6A5DA0",
"TECH BL/ CHAR": "#4A484D",
"TECH MAROON": "#5D2735",
"TECH PINK": "#EAB2BD",
"TECH RED": "#D9868E",
"TECH ROYAL": "#557EC0",
"TERRACOTA": "#E09582",
"TIFF BLUE": "#5BB8AE",
"TILE RED": "#7F383A",
"TITANIUM": "#A09697",
"TOBACCO": "#6B5849",
"TOBACO/ FLD KHKI": "#443323",
"TR ROYAL TRIBLD": "#69B6F5",
"TR ROYAL TRIBLND": "#575F8E",
"TR ROYAL/ BLACK": "#003594",
"TRI ATHLETIC GRY": "#A09FA5",
"TRI BLACK": "#000000",
"TRI BURGUNDY": "#5A4556",
"TRI CHARCOAL": "#47454A",
"TRI DARK GREY": "#5E5E68",
"TRI DENIM": "#7085B4",
"TRI GREY": "#53535A",
"TRI LIGHT BLUE": "#B3D0E9",
"TRI MAROON": "#945174",
"TRI ROYAL BLUE": "#1B55B9",
"TRI STEEL": "#46526A",
"TROPICAL JUNGLE": "#727473",
"TRU BLU HTH/ OXF": "#1D4F91",
"TRU ROYAL TRBLND": "#285FA2",
"TRU ROYAL/ CRBN": "#003594",
"TRUE BLACK": "#1E1920",
"TRUE BLUE HEATHR": "#1D4F91",
"TRUE NAVY": "#252936",
"TRUE NAVY TRBLND": "#353F5B",
"TRUE RED": "#A7192D",
"TRUE RED STARS": "#E51F38",
"TRUE ROYAL": "#234696",
"TRUE ROYAL TRBLD": "#285FA2",
"TRUE ROYAL TRBLN": "#285FA2",
"TRUE ROYAL TRIBD": "#285FA2",
"TRUE ROYAL/ BLK": "#004E91",
"TRUE ROYAL/ WHT": "#0053A2",
"TULIP": "#FFB6C1",
"TULP/ CLNTRO/ WH": "#D69FB5",
"TURF GREEN": "#067C4A",
"TURQ INVSBL STRP": "#00C2F7",
"TURQBERRY": "#00828C",
"TURQUOISE": "#0091D5",
"TURQUOISE FLECK": "#0095C6",
"TURQUOISE TRBLND": "#41C2DF",
"TURQUOISE/ BLACK": "#28A3E3",
"TURQUOISE/ SILVR": "#38A5A0",
"TWEED": "#616469",
"TWILIGHT BLACK": "#2F2E31",
"TWISTED BLACK": "#464749",
"TWISTED BORDEAUX": "#6F2C3F",
"TWISTED OLIVE": "#3D441E",
"TWISTED PLUM": "#5D4777",
"TWISTED ROYAL": "#4271B5",
"Tahiti": "#1D698D",
"Tahiti Blue": "#79CFE8",
"Tan": "#CFB59E",
"Tan Camo": "#B59F88",
"Tan Duck Camo": "#000000",
"Tan/ Loden/ Brown": "#B5A186",
"Tan/ Navy/ Olive Green": "#E1D9C5",
"Tan/ Realtree Max4": "#d3b198",
"Tangerine Heather": "#d86839",
"Tangerine Orange": "#F08223",
"Tangier": "#000000",
"Tank": "#a8a99e",
"Taupe": "#94613f",
"Teal": "#1BA4D0",
"Teal/ Orange": "#1E6B7F",
"Team Purple": "#6A5DA0",
"Teardrop": "#2d333c",
"Teddy Brown": "#2e1e16",
"Terra Brown": "#7A6855",
"Terracotta": "#E8927C",
"Terracotta/ Cinder": "#c16c4b",
"Texas Orange": "#B65A2B",
"Texas Orange/ Khaki": "#c16c4b",
"Texas Orange/ Stone": "#c16c4b",
"Texas Orange/ White": "#A65523",
"Throwback Black": "#000000",
"Thunder Cloud": "#494643",
"Tie Dye Aqua Blue": "#70c8c3",
"Tie Dye Black": "#1b1d1e",
"Tie Dye Cotton Candy": "#fbd6e1",
"Tie Dye Dusty Pink": "#fbd6e1",
"Tie Dye Navy": "#212b3e",
"Tie Dye Olive": "#3D4033",
"Tie Dye Pink": "#fbd6e1",
"Tie Dye Sunset Swirl": "#fbd6e1",
"Tie-Dye Slate Blue": "#8FA3A4",
"Tiger Camo": "#000000",
"Titanium Blue": "#5B798E",
"Toast": "#9E6A38",
"Toasted Coconut": "#f8f3e3",
"Tobacco/ Black Buffalo": "#554631",
"Top Sail Red": "#f80808",
"Tradewind": "#489fdf",
"Tradewind Spot": "#489fdf",
"Trees & Peaks/ Navy": "#333e59",
"Tri Black": "#000000",
"Tri Blue": "#224D8F",
"Tri Brown": "#382F2D",
"Tri Grey": "#53535A",
"Tri Navy": "#263147",
"Tri Oatmeal": "#E6E1DD",
"Tri-Black": "#000000",
"Tri-Cranberry": "#8e1a24",
"Tri-Indigo": "#162631",
"Tri-White": "#ffffff",
"Tropical Blue Leaves/ Navy": "#7BC8D0",
"Trout Dusk": "#526b7f",
"Trout Grey": "#848283",
"Trout Olive": "#807c6c",
"Trout Olive Green": "#807c6c",
"Trout Skin": "#ddd5c1",
"Trout Spots/ Brown": "#B59F88",
"Trout Spots/ Grey": "#848283",
"True Kelly Green": "#00774f",
"True Navy": "#252936",
"True Navy Triblend": "#1c2236",
"True Navy/ Heather Grey": "#333e59",
"True Navy/ Heather/ White": "#333e59",
"True Navy/ Silver": "#333e59",
"True Navy/ True Red/ White": "#333e59",
"True Navy/ White": "#333e59",
"True Navy/ White/ True Red Stars": "#333e59",
"True Navy/ White/ True Red USA": "#333e59",
"True Red": "#A7192D",
"True Red/ Heather": "#BA0C2F",
"True Red/ Silver": "#BA0C2F",
"True Red/ White": "#BA0C2F",
"True Royal": "#234696",
"True Royal/ Black": "#224D8F",
"True Royal/ Carbon": "#224D8F",
"True Royal/ Classic Navy Heather": "#224D8F",
"True Royal/ Heather": "#1C3775",
"True Royal/ Heather/ White": "#1C3775",
"True Royal/ Silver": "#1C3775",
"True Royal/ White": "#1C3775",
"Turquoise": "#0091D5",
"Turquoise Heather": "#007dba",
"Twilight Black": "#2F2E31",
"Twisted Black": "#464749",
"URBAN WOODLAND": "#D5D7D6",
"USA": "#E9114A",
"USA Flag": "#333e59",
"Umber": "#d46c36",
"Unicorn": "#c5b4e3",
"Urban Camo": "#000000",
"V HT PNK/ BD WHT": "#E24585",
"V SM/ V CM/ V HT": "#101820",
"V SM/ V HT/ V SM": "#101820",
"V SMK/ V CMO/ BK": "#2D2B2E",
"VARSITY GREEN": "#2C382E",
"VENETIAN GRAY": "#6D6E71",
"VERY BERRY": "#7F558C",
"VIBRANT YELLOW": "#FFF200",
"VIN COAL/ BLK": "#8B8381",
"VIN HTR NAVY": "#062B60",
"VIN LIGHT ORANG": "#E99578",
"VIN ROYL/ WH/ RD": "#304074",
"VIN TURQUOISE": "#41A3D8",
"VINT FADED PINK": "#E0CFC8",
"VINT GREEN/ WHT": "#007A3E",
"VINT HTR BLUE": "#2E4071",
"VINT HTR RED": "#E01962",
"VINT NV/ VINT WH": "#131735",
"VINT ROYAL/ RED": "#304074",
"VINT SMOKE/ BLK": "#101820",
"VINTAGE CHARCOAL": "#9AA5AA",
"VINTAGE COAL": "#7F7E84",
"VINTAGE GRASS": "#6C8E68",
"VINTAGE HTR NAVY": "#062B60",
"VINTAGE IRIS": "#9F779A",
"VINTAGE LILAC": "#CDA7C8",
"VINTAGE NAVY": "#2A314D",
"VINTAGE NVY/ NVY": "#93929A",
"VINTAGE PINE": "#959E8D",
"VINTAGE PINK": "#FBD0E6",
"VINTAGE PURPLE": "#584C54",
"VINTAGE RED": "#CB101B",
"VINTAGE RED/ WHT": "#A6192E",
"VINTAGE ROSE": "#AF8382",
"VINTAGE ROY/ WHT": "#2C5FC8",
"VINTAGE ROYAL": "#2E54A7",
"VINTAGE SH PINK": "#A7254B",
"VINTAGE TURQ": "#6AD9F4",
"VINTAGE WHITE": "#E9E4DE",
"VINTAGE WINE": "#77202F",
"VINTGE CAMO/ BLK": "#555C6E",
"VIOLET": "#94A1E2",
"VN CAMO/ VN SMK": "#555C6E",
"VN HT/ VN BRG/ W": "#A7A8AA",
"VN HT/ VN HT PNK": "#A7A8AA",
"VN HTH/ VN NV/ W": "#A7A8AA",
"VN HTH/ VN RD/ W": "#A7A8AA",
"VN HTH/ VN ROYAL": "#A7A8AA",
"VN HTH/ VN RY/ W": "#A7A8AA",
"VN HTH/ VN SMOKE": "#A7A8AA",
"VN HTHR/ BLD WHT": "#A7A8AA",
"VN HTHR/ VN NAVY": "#A7A8AA",
"VN HTHR/ VN RED": "#A7A8AA",
"VN HTHR/ VN ROY": "#A7A8AA",
"VN NAVY/ BLD WHT": "#051C2C",
"VN RED/ BLD WHT": "#A6192E",
"VN ROYAL/ BD WHT": "#1D4289",
"VN ROYAL/ BL WHT": "#1D4289",
"VN SMK/ BL WHT": "#101820",
"VN SMK/ GRAN HTH": "#101820",
"VN SMKE/ VN CAMO": "#535258",
"VN SMOKE/ BD WHT": "#101820",
"VNT COAL/ BLACK": "#B2A89F",
"VNT COAL/ WH/ NV": "#70635C",
"VNT FADED PINK": "#E0CFC8",
"VNT ROYAL/ WHITE": "#304074",
"Vanilla/ Longhorn": "#E7CEB5",
"Vanilla/ Longhorn/ Khaki": "#E7CEB5",
"Vanilla/ Red Ribbon/ Dark Navy": "#000000",
"Vanilla/ Tonal Longhorn/ Vanilla": "#E7CEB5",
"Vanilla/ White": "#E7CEB5",
"Vapor": "#7C878E",
"Vegas Gold": "#F1D484",
"Vegas Gold/ White": "#e4cf9b",
"Vintage Arctic": "#D7D2CB",
"Vintage Black": "#000000",
"Vintage Blue": "#3474a6",
"Vintage Blue/ Khaki": "#003865",
"Vintage Brown": "#86715A",
"Vintage Camel": "#F4D1A1",
"Vintage Camo": "#626355",
"Vintage Coffee": "#705853",
"Vintage Denim": "#5879A2",
"Vintage Gold": "#DDA300",
"Vintage Heather Grey": "#969a9c",
"Vintage Lake": "#69B3E7",
"Vintage Military Green": "#7f8957",
"Vintage Mustard": "#FFA300",
"Vintage Navy": "#2A314D",
"Vintage Navy/ Stone": "#333e59",
"Vintage Olive": "#353b23",
"Vintage Purple": "#584C54",
"Vintage Red": "#CB101B",
"Vintage Red/ Khaki": "#9D2235",
"Vintage Smoke": "#101820",
"Vintage Smoke/ Black Leopard": "#302c28",
"Vintage Tiger Camo": "#000000",
"Vintage True Navy": "#0c2340",
"Vintage White": "#E9E4DE",
"Vintage White/ Black": "#fcf9f2",
"Vintage White/ Inked India": "#fcf9f2",
"Vintage White/ Mellow Yellow": "#fcf9f2",
"Vintage White/ Rio Red": "#fcf9f2",
"Vintage Zinc": "#66676C",
"Violet": "#94A1E2",
"Violet/ Floral": "#c5b4e3",
"Violet/ Floral/ Khaki": "#c5b4e3",
"Violet/ Snow Leopard": "#c5b4e3",
"Violet/ White": "#c5b4e3",
"Vivid Blue": "#1484F0",
"Volcanic Ash": "#C8C9C7",
"Volcanic Ash Heather": "#C8C9C7",
"WARM GRAY": "#8E8F8A",
"WASHED BLACK": "#2A2A2A",
"WATERMELON": "#E6818C",
"WEDGEWOOD": "#67779A",
"WHITE": "#FFFFFF",
"WHITE / BLACK": "#FFFFFF",
"WHITE / MAIZE": "#FFFFFF",
"WHITE / NAVY": "#FFFFFF",
"WHITE / RED": "#FFFFFF",
"WHITE / VNT ROY": "#FFFFFF",
"WHITE BLIZZARD": "#EDEDED",
"WHITE FLECK TRB": "#FFFFFF",
"WHITE FLK TRBLND": "#EDE9E8",
"WHITE MARBLE": "#FFFFFF",
"WHITE REACTIVE": "#FFFFFF",
"WHITE SLUB": "#FCFCFC",
"WHITE SUBLMTN": "#F2F2F4",
"WHITE/ BLACK": "#FFFFFF",
"WHITE/ BLACK INK": "#F7F7F7",
"WHITE/ CHAR HTHR": "#F7F7F7",
"WHITE/ CHRCL FLK": "#FFFFFF",
"WHITE/ CONCRETE": "#F0F0F0",
"WHITE/ DEEP RED": "#FFFFFF",
"WHITE/ DENIM": "#FFFFFF",
"WHITE/ DP ROYAL": "#FFFFFF",
"WHITE/ DP VIOLET": "#FFFFFF",
"WHITE/ GOLD": "#F9D160",
"WHITE/ GRAY": "#FFFFFF",
"WHITE/ HELICONIA": "#FFFFFF",
"WHITE/ HTH PEACH": "#FFFFFF",
"WHITE/ HTHER GRY": "#FFFFFF",
"WHITE/ HTHR GRAY": "#FFFFFF",
"WHITE/ J NAVY": "#F7F7F7",
"WHITE/ JADE": "#E5E1E6",
"WHITE/ LT BLUE": "#FFFFFF",
"WHITE/ MAIZE": "#FFFFFF",
"WHITE/ NAVY": "#FFFFFF",
"WHITE/ PURPLE": "#52478D",
"WHITE/ RED": "#FFFFFF",
"WHITE/ ROYAL": "#FFFFFF",
"WHITE/ SCUBA BLU": "#F7F7F7",
"WHITE/ SP SILVER": "#FFFFFF",
"WHITE/ STHRN ORN": "#FFFFFF",
"WHITE/ SUNRY YLW": "#FFFFFF",
"WHITE/ TITANIUM": "#FFFFFF",
"WHITE/ TR ROYAL": "#FFFFFF",
"WHITE/ TRUE RED": "#F7F7F7",
"WHITE/ VNT ROY": "#FFFFFF",
"WHITE/ VNT ROYAL": "#FFFFFF",
"WHT FLECK TRBD": "#FFFFFF",
"WHT FLECK TRIBLD": "#FFFFFF",
"WHT HTH/ BLK HTH": "#F7F7F7",
"WHT INVSBL STRP": "#EDECF1",
"WHT/ CAROLNA BLU": "#FFFFFF",
"WHT/ COLUM BLUE": "#E5E1E6",
"WHT/ GRPH/ LT GR": "#FFFFFF",
"WHT/ HTHR GRAY": "#FFFFFF",
"WHT/ LT FR B/ FB": "#FFFFFF",
"WHT/ LT FR BLUE": "#FFFFFF",
"WHT/ TITANM/ BLK": "#FFFFFF",
"WILD PLUM": "#5E2751",
"WILDBERRY": "#A73B67",
"WILDBERRY HTHR": "#E63375",
"WINE": "#7C2020",
"WOODSTOCK": "#F7B810",
"WOW PINK": "#E7528A",
"Walnut": "#B59F88",
"Wanderlust": "#7e93a7",
"Washed Banana Cream": "#f8e08e",
"Washed Basil": "#596c62",
"Washed Black": "#2A2A2A",
"Washed Cardinal": "#862633",
"Washed Charcoal": "#525150",
"Washed Chestnut": "#7B5852",
"Washed Cocoa": "#67584F",
"Washed Coyote Brown": "#8B7C5E",
"Washed Denim": "#4D5F80",
"Washed Graphite Black": "#373a36",
"Washed Grey": "#B2B4B2",
"Washed Maroon": "#6D4F52",
"Washed Mauve": "#ad6a63",
"Washed Mauvelous": "#D0858A",
"Washed Military Green": "#3e4827",
"Washed Natural": "#Dfd1a7",
"Washed Navy": "#434B56",
"Washed Pine": "#485C55",
"Washed Purple Rush": "#582c83",
"Washed Rouge": "#8E3950",
"Washed Royal": "#0057b8",
"Washed Royal Pine": "#425750",
"Washed Saltwater": "#548980",
"Washed Stonewash Denim": "#A4B5CB",
"Washed Tradewind": "#489fdf",
"Washed White": "#ffffff",
"Watercolor Sunset/ Teal": "#1E6B7F",
"Wave": "#69B3E7",
"Weathered Brown": "#876155",
"Weathered Mauvelous": "#E9A2B2",
"Weathered Military Green": "#626951",
"Weathered Plum": "#4b3048",
"Weathered Red": "#b62730",
"Weathered Red/ Cinder": "#b62730",
"Wheat": "#B59F88",
"Wheat/ Denim": "#d8a462",
"Wheatfield/ Black": "#000000",
"White": "#FFFFFF",
"White - B124": "#d8d8d8",
"White Bone Fish": "#ffffff",
"White Camo": "#ffffff",
"White Camo/ White": "#e3e7ed",
"White Grey Topo": "#b1aca8",
"White Heathered": "#f4f7ff",
"White Lobster": "#ffffff",
"White Multi": "#ffffff",
"White Realtree AP": "#F2F8F8",
"White Reptile": "#ffffff",
"White Shamrock": "#ffffff",
"White Skulls": "#ffffff",
"White Spot": "#ffffff",
"White Stars": "#ffffff",
"White Tropical": "#ffffff",
"White Z - Quilted": "#ededed",
"White-Red/ White/ Royal": "#FFFFFF",
"White/ Aluminum Camo": "#d7dbdd",
"White/ Aqua Camo": "#8ed0cf",
"White/ Baby Blue": "#e3e7ed",
"White/ Black": "#FFFFFF",
"White/ Black Heather": "#ffffff",
"White/ Black/ Black": "#ffffff",
"White/ Black/ Black/ White": "#ffffff",
"White/ Black/ Orange Tri": "#e3e7ed",
"White/ Blue Hawaiin/ Pale Orange": "#e3e7ed",
"White/ Blue Mist Camo": "#8fb1dc",
"White/ Blue/ Red/ White": "#ffffff",
"White/ Burgundy/ Black": "#ffffff",
"White/ Burgundy/ Silver": "#ffffff",
"White/ Caramel/ Brown": "#ffffff",
"White/ Charcoal": "#e3e7ed",
"White/ Charcoal Heather": "#e8e8e8",
"White/ Charcoal/ Black": "#e3e7ed",
"White/ Charcoal/ Orange": "#ffffff",
"White/ Columbia Blue/ Brown": "#e3e7ed",
"White/ Columbia Blue/ Red Tri": "#e3e7ed",
"White/ Dark Green": "#ffffff",
"White/ Dark Grey": "#FFFFFF",
"White/ Dusty Rose": "#e3e7ed",
"White/ Floral": "#ffffff",
"White/ Forest": "#ffffff",
"White/ Forest/ Lime": "#ffffff",
"White/ Graphite": "#ffffff",
"White/ Graphite Heather": "#FFFFFF",
"White/ Green": "#ffffff",
"White/ Green-Yellow": "#ffffff",
"White/ Green/ Yellow": "#ffffff",
"White/ Grey": "#e3e7ed",
"White/ Heather Grey": "#e3e7ed",
"White/ Heather Lake Blue": "#f1f0f0",
"White/ Hot Pink": "#FFFFFF",
"White/ Imperial Navy/ Red": "#ffffff",
"White/ Indigo/ Dark Navy": "#ffffff",
"White/ Kelly": "#FFFFFF",
"White/ Khaki": "#ffffff",
"White/ Light Blue": "#ffffff",
"White/ Light Blue-Red": "#ffffff",
"White/ Light Navy": "#ffffff",
"White/ Lilac Stripe": "#ffffff",
"White/ Maroon": "#FFFFFF",
"White/ Metallic Gold": "#ffffff",
"White/ Nassau/ Charcoal": "#ffffff",
"White/ Navy": "#FFFFFF",
"White/ Navy-Red": "#ffffff",
"White/ Navy/ Crystal": "#ffffff",
"White/ Navy/ Grey": "#FFFFFF",
"White/ Navy/ Navy": "#ffffff",
"White/ Navy/ Navy/ Red/ White": "#ffffff",
"White/ Navy/ Neon": "#ffffff",
"White/ Navy/ Red": "#ededed",
"White/ Navy/ White/ Red": "#ffffff",
"White/ Neon Heather Pink": "#ffffff",
"White/ Orange": "#F7753B",
"White/ Oxford Heather": "#F4F9FF",
"White/ Peach": "#ffffff",
"White/ Pink": "#FFFFFF",
"White/ Rainbow": "#ffffff",
"White/ Red": "#FFFFFF",
"White/ Red-Black": "#ffffff",
"White/ Red/ Dark Navy": "#FFFFFF",
"White/ Red/ Royal": "#ffffff",
"White/ Red/ Sky Blue": "#FFFFFF",
"White/ Royal": "#FFFFFF",
"White/ Royal/ Red": "#e3e7ed",
"White/ Royal/ Red Tri": "#305791",
"White/ Rust/ Stone": "#ffffff",
"White/ Silver": "#ffffff",
"White/ Silver/ Slate": "#ffffff",
"White/ Smoke Blue": "#ffffff",
"White/ Sport Dark Navy Heather": "#ffffff",
"White/ Sport Silver": "#ffffff",
"White/ Teal-Purple": "#ffffff",
"White/ True Royal": "#ffffff",
"White/ Truffle": "#f1f0f0",
"White/ USA Flag": "#FFFFFF",
"White/ Wheat/ Elmwood": "#ffffff",
"White/ White": "#FFFFFF",
"White/ White Spot": "#ffffff",
"White/ White/ Black": "#ffffff",
"White/ White/ Navy": "#ffffff",
"White/Black": "#FFFFFF",
"Whitewash": "#ffffff",
"Wildflower": "#2d333c",
"Windsurfer": "#7ba4db",
"Wine": "#7C2020",
"Winter Blue": "#3474a6",
"Winter Green": "#32572b",
"Wisteria Blackout": "#8e7fae",
"Wisteria Pink": "#c0869b",
"Wisteria Pink/ White": "#c0869b",
"Woodgrain": "#382F2D",
"Woodland Camo": "#000000",
"Woodland/ Khaki": "#4E4934",
"X Hatch Black/ Black": "#1b151a",
"X Hatch Grey/ White": "#848283",
"X Hatch Khaki/ Black": "#B59F88",
"X Hatch Red/ Khaki": "#b62730",
"Xtra/ USA Flag": "#8d7453",
"Xtra/ Xtra/ USA Flag Mesh": "#8d7453",
"YELLOW": "#FDFB71",
"YELLOW OCHRE": "#EAC871",
"YLLW GLD TRBLND": "#FFC533",
"YLW GOLD TRBLND": "#FDBB31",
"Yam": "#BE531C",
"Yellow": "#FDFB71",
"Yellow - B125": "#C8FE2E",
"Yellow Fluorescent": "#fced00",
"Yellow/ Khaki": "#eba857",
"Yellow/ Marine/ White": "#fced00",
"Zen Rainbow": "#F67599",
"Zephyr": "#F67599"
};
  var norm = function (s) { return (s || '').trim().toUpperCase(); };
  /* C333 (2026-09-23): every lookup uppercases the colour name, but 1,937 of the 2,798 keys are
     mixed case ("Brown/ Stone Stitch"), so those names could never be found and their swatches fell
     back to plain grey — 11 of the VC300A hat's 42 colours. Add an uppercase alias for each such
     key. An existing uppercase key always wins, so no colour that paints today changes. */
  Object.keys(MAP).forEach(function (k) {
    var u = norm(k).replace(/\s+/g, ' ');
    if (!Object.prototype.hasOwnProperty.call(MAP, u)) MAP[u] = MAP[k];
  });
  window.NP_BLANK_COLORS = MAP;

  function paint(root) {
    var els = (root || document).querySelectorAll('.product-variant__item-swatch, [data-colorname], [class*="colorOption"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-np-swatch') === '1') continue;
      /* the colour NAME is not on the swatch. The theme prints style="background-color:<name with
         spaces stripped>" (invalid CSS, paints nothing) and puts the readable name in the
         enclosing label's text: <label class="product-variant__label">...<span swatch>CAROLINA BLUE.
         Probe first, assume never — this is the mistake the handoff calls out. */
      var lab = el.closest ? el.closest('label') : null;
      var name = el.getAttribute('data-colorname') || el.getAttribute('title')
              || el.getAttribute('aria-label')
              || (lab && lab.textContent) || (el.parentNode && el.parentNode.textContent) || '';
      var hex = MAP[norm(name)] || MAP[name.trim()];
      if (!hex) {
        for (var k in MAP) { if (norm(k) === norm(name)) { hex = MAP[k]; break; } }
      }
      if (!hex) continue;
      /* only fill a swatch that has no usable colour: products with real metafields stay untouched */
      var bg = window.getComputedStyle(el).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') { el.setAttribute('data-np-swatch','1'); continue; }
      /* nothing painted: the inline background-color is the stripped-name string and is invalid */
      el.style.backgroundColor = hex;
      el.setAttribute('data-np-swatch', '1');
    }
  }

  paint(document);
  /* the picker re-renders on every colour and size change, and quick buy injects its own copy */
  new MutationObserver(function () { paint(document); })
    .observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('variant:change', function () { paint(document); });
})();
